{
  "level": "cc01a",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:cc01a",
    "objects": "AREAS.E3:cc01a.e3",
    "mesh": "TREES.E3:cc01a.e3"
  },
  "spawn_point": {
    "position": [
      -1529.7554772564392,
      -15.500387040750722,
      -276.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -1529.7554772564392,
      84.49961295924928,
      -276.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -5545.388671875,
      -4693.75146484375,
      -300.0
    ],
    "bbox_max": [
      6992.10546875,
      7262.134765625,
      1814.080322265625
    ],
    "vertex_count": 1023,
    "vertices": [
      [
        -3714.042724609375,
        -2323.521484375,
        1179.1292724609375
      ],
      [
        -5545.388671875,
        4741.15380859375,
        334.12225341796875
      ],
      [
        -3697.7392578125,
        -2384.4521484375,
        1181.5667724609375
      ],
      [
        -3709.58251953125,
        -2363.246337890625,
        1182.9832763671875
      ],
      [
        -3605.362548828125,
        -2269.30224609375,
        2.0755867958068848
      ],
      [
        -3614.939453125,
        -3588.4169921875,
        1317.599365234375
      ],
      [
        -4205.0,
        -2619.44677734375,
        1400.274658203125
      ],
      [
        -3461.15576171875,
        -4521.4228515625,
        1390.116943359375
      ],
      [
        -3093.3369140625,
        -4604.0595703125,
        1170.251708984375
      ],
      [
        -3095.20947265625,
        -4636.2900390625,
        1271.65087890625
      ],
      [
        -3412.67578125,
        -3448.206787109375,
        1220.0
      ],
      [
        -3411.630126953125,
        -3453.730224609375,
        1224.3428955078125
      ],
      [
        -3502.183349609375,
        -3576.798583984375,
        1274.598876953125
      ],
      [
        -3502.183349609375,
        -3576.798583984375,
        1274.598876953125
      ],
      [
        -3614.939453125,
        -3588.4169921875,
        1317.599365234375
      ],
      [
        -3605.362548828125,
        -2269.30224609375,
        2.0755615234375
      ],
      [
        -3709.58251953125,
        -2363.246337890625,
        1182.983154296875
      ],
      [
        -3714.01416015625,
        -2323.6279296875,
        1179.1334228515625
      ],
      [
        -4474.53173828125,
        4475.62646484375,
        150.0
      ],
      [
        -4591.42333984375,
        5531.40869140625,
        150.0
      ],
      [
        -2916.739501953125,
        3191.2431640625,
        124.09432983398438
      ],
      [
        -3179.908447265625,
        3702.748046875,
        150.0
      ],
      [
        -4020.98193359375,
        5936.4208984375,
        150.0
      ],
      [
        -2638.939453125,
        3351.18505859375,
        0.0
      ],
      [
        -2650.5576171875,
        3351.36181640625,
        4.2407684326171875
      ],
      [
        -2638.939453125,
        3351.18505859375,
        0.0
      ],
      [
        -2609.847900390625,
        3350.7421875,
        -10.6187744140625
      ],
      [
        -2501.9697265625,
        3265.2880859375,
        -300.0
      ],
      [
        -1156.463623046875,
        -2051.8349609375,
        202.6451416015625
      ],
      [
        -200.806640625,
        -3123.862548828125,
        0.0
      ],
      [
        -1942.9771728515625,
        -3113.202392578125,
        638.1046142578125
      ],
      [
        -2286.8662109375,
        -3329.22607421875,
        794.213623046875
      ],
      [
        -2912.14697265625,
        -4693.75146484375,
        1212.388916015625
      ],
      [
        -1700.7498779296875,
        -2507.029541015625,
        -300.0
      ],
      [
        -2808.593505859375,
        -3513.30859375,
        1011.1946411132812
      ],
      [
        -2908.152099609375,
        -3548.43603515625,
        1052.5999755859375
      ],
      [
        -3058.93505859375,
        -3479.345703125,
        1098.404052734375
      ],
      [
        -3009.681640625,
        -3300.586181640625,
        1055.611572265625
      ],
      [
        -3403.8046875,
        -3443.094970703125,
        1220.0
      ],
      [
        -3714.02197265625,
        -2323.558349609375,
        1179.126708984375
      ],
      [
        -2286.865966796875,
        -3329.22607421875,
        794.213623046875
      ],
      [
        -3697.488525390625,
        -2384.901123046875,
        1181.5367431640625
      ],
      [
        -2981.017578125,
        -3196.55322265625,
        1030.70751953125
      ],
      [
        -2981.017578125,
        -3196.55322265625,
        1030.70751953125
      ],
      [
        -3070.88916015625,
        -3126.308349609375,
        1053.9906005859375
      ],
      [
        -3662.39306640625,
        -2424.959228515625,
        1174.18994140625
      ],
      [
        -3070.88916015625,
        -3126.308349609375,
        1053.9906005859375
      ],
      [
        -3697.488525390625,
        -2384.901123046875,
        1181.53662109375
      ],
      [
        -3662.39306640625,
        -2424.959228515625,
        1174.18994140625
      ],
      [
        -2931.503662109375,
        -106.0,
        100.0
      ],
      [
        -3005.934326171875,
        -24.0,
        100.0
      ],
      [
        -2895.29443359375,
        -145.8916015625,
        100.0
      ],
      [
        -2874.40625,
        -168.90383911132812,
        100.0
      ],
      [
        -3009.565185546875,
        -20.0,
        100.0
      ],
      [
        -3008.63330078125,
        -21.5,
        95.0
      ],
      [
        -3005.6767578125,
        -24.0,
        103.0
      ],
      [
        -3007.491943359375,
        -22.0,
        103.0
      ],
      [
        -3007.491943359375,
        -22.0,
        103.0
      ],
      [
        -3009.5654296875,
        -20.0,
        100.0
      ],
      [
        -1529.63916015625,
        -2745.022216796875,
        435.4664001464844
      ],
      [
        -1180.669189453125,
        -2147.973876953125,
        224.8211669921875
      ],
      [
        -1288.892333984375,
        -1953.526123046875,
        -300.0
      ],
      [
        -1942.9771728515625,
        -3113.202392578125,
        638.1046142578125
      ],
      [
        -1655.49462890625,
        -2876.868896484375,
        499.8956298828125
      ],
      [
        -1655.49462890625,
        -2876.868896484375,
        499.8956604003906
      ],
      [
        -1529.63916015625,
        -2745.02197265625,
        435.46630859375
      ],
      [
        -1180.669189453125,
        -2147.973876953125,
        224.82118225097656
      ],
      [
        -1156.463623046875,
        -2051.8349609375,
        202.6451416015625
      ],
      [
        -1877.876708984375,
        1330.0,
        0.0
      ],
      [
        -1846.306884765625,
        1326.306884765625,
        -11.079254150390625
      ],
      [
        -1817.047119140625,
        3338.672607421875,
        -300.0
      ],
      [
        -1807.8961181640625,
        2057.896240234375,
        -126.31155395507812
      ],
      [
        -1846.306884765625,
        1326.306884765625,
        -11.07925033569336
      ],
      [
        -1445.5028076171875,
        2015.5028076171875,
        -253.49160766601562
      ],
      [
        -1807.8961181640625,
        2057.896240234375,
        -126.31155395507812
      ],
      [
        -1430.0,
        2310.7763671875,
        -300.0
      ],
      [
        -1445.5028076171875,
        2015.5028076171875,
        -253.49160766601562
      ],
      [
        -1425.26611328125,
        127.9840087890625,
        0.0
      ],
      [
        -1508.86181640625,
        750.1992797851562,
        -55.32252502441406
      ],
      [
        -2422.6640625,
        1330.0,
        200.0
      ],
      [
        -1877.876708984375,
        1330.0,
        0.0
      ],
      [
        -1800.0855712890625,
        400.0,
        100.0
      ],
      [
        -1803.8509521484375,
        410.0,
        100.0
      ],
      [
        -1781.2584228515625,
        350.0,
        100.0
      ],
      [
        -1800.0855712890625,
        400.0,
        100.0
      ],
      [
        -1651.897705078125,
        6.4517059326171875,
        100.0
      ],
      [
        -1638.27099609375,
        -29.7373046875,
        100.0
      ],
      [
        -1664.7186279296875,
        40.500694274902344,
        100.0
      ],
      [
        -1651.897705078125,
        6.4517059326171875,
        100.0
      ],
      [
        -1638.27099609375,
        -29.73729705810547,
        100.0
      ],
      [
        -1625.1802978515625,
        -64.50291442871094,
        100.0
      ],
      [
        -1675.62646484375,
        69.46905517578125,
        100.0
      ],
      [
        -1664.7186279296875,
        40.50069808959961,
        100.0
      ],
      [
        -1675.62646484375,
        69.46905517578125,
        100.0
      ],
      [
        -1781.2584228515625,
        350.0,
        100.0
      ],
      [
        -1869.09228515625,
        583.2640380859375,
        100.0
      ],
      [
        -1820.0,
        452.8876647949219,
        100.0
      ],
      [
        -1625.18017578125,
        -64.50289916992188,
        100.0
      ],
      [
        -1609.5274658203125,
        -106.07269287109375,
        100.0
      ],
      [
        -1875.1744384765625,
        599.41650390625,
        100.0
      ],
      [
        -1869.09228515625,
        583.2640380859375,
        100.0
      ],
      [
        -1875.1744384765625,
        599.41650390625,
        100.0
      ],
      [
        -1878.997802734375,
        609.5703735351562,
        100.0
      ],
      [
        -1881.21875,
        615.4686279296875,
        100.0
      ],
      [
        -1878.9976806640625,
        609.5703735351562,
        100.0
      ],
      [
        -1127.99072265625,
        -1680.405029296875,
        0.0
      ],
      [
        -1124.295654296875,
        -1528.0806884765625,
        -85.06402587890625
      ],
      [
        -1126.419921875,
        -2028.7181396484375,
        100.0
      ],
      [
        -1127.99072265625,
        -1680.405029296875,
        0.0
      ],
      [
        -1114.0142822265625,
        -1970.922119140625,
        100.0
      ],
      [
        -1124.295654296875,
        -1528.0806884765625,
        -85.06402587890625
      ],
      [
        -1067.126220703125,
        -1434.1708984375,
        -300.0
      ],
      [
        -2560.0,
        662.5,
        35.0
      ],
      [
        -2560.0,
        640.8333129882812,
        35.0
      ],
      [
        -1425.26611328125,
        127.98397827148438,
        0.0
      ],
      [
        -1420.4962158203125,
        86.82951354980469,
        3.9378738403320312
      ],
      [
        -1820.0,
        452.8876647949219,
        100.0
      ],
      [
        -1720.0,
        476.6761474609375,
        60.0
      ],
      [
        -2340.0,
        702.5,
        45.000003814697266
      ],
      [
        -2340.0,
        666.3665161132812,
        55.3238525390625
      ],
      [
        -1803.8509521484375,
        410.0,
        100.0
      ],
      [
        -1694.8935546875,
        410.0,
        60.0
      ],
      [
        -1694.8935546875,
        410.0,
        60.0
      ],
      [
        -1720.0,
        476.6761474609375,
        60.0
      ],
      [
        -2703.0,
        -122.0,
        103.0
      ],
      [
        -2611.0,
        -122.0,
        103.0
      ],
      [
        -1872.76171875,
        -122.0,
        102.0
      ],
      [
        -1850.193115234375,
        -122.0,
        102.0
      ],
      [
        -1883.6041259765625,
        -122.0,
        102.0
      ],
      [
        -1875.0185546875,
        -122.0,
        102.0
      ],
      [
        -1883.6041259765625,
        -122.0,
        102.0
      ],
      [
        -1944.61669921875,
        -122.0,
        102.0
      ],
      [
        -1850.193115234375,
        -122.0,
        100.0
      ],
      [
        -1850.193115234375,
        -122.0,
        102.0
      ],
      [
        -1800.57275390625,
        -252.0,
        100.0
      ],
      [
        -1800.57275390625,
        -252.0,
        102.0
      ],
      [
        -1844.0,
        -252.0,
        102.0
      ],
      [
        -1983.111083984375,
        -270.0,
        102.0
      ],
      [
        -1960.0,
        -270.0,
        102.0
      ],
      [
        -1785.0,
        -303.33642578125,
        100.0
      ],
      [
        -1785.0,
        -320.0,
        102.0
      ],
      [
        -1785.0,
        -303.33642578125,
        102.0
      ],
      [
        -1800.0,
        -270.0,
        102.0
      ],
      [
        -1792.984375,
        -277.01568603515625,
        100.0
      ],
      [
        -1792.984375,
        -277.01568603515625,
        102.0
      ],
      [
        -1800.0,
        -253.8881378173828,
        100.0
      ],
      [
        -1800.0,
        -270.0,
        102.0
      ],
      [
        -1800.0,
        -253.8881378173828,
        102.0
      ],
      [
        -1983.111083984375,
        -270.0,
        102.0
      ],
      [
        -1983.111083984375,
        -267.5752258300781,
        102.0
      ],
      [
        -1984.1668701171875,
        -267.7796936035156,
        102.0
      ],
      [
        -1983.111083984375,
        -267.5752258300781,
        102.0
      ],
      [
        -1124.9234619140625,
        -2028.8587646484375,
        102.0
      ],
      [
        -1113.7347412109375,
        -1976.7325439453125,
        102.0
      ],
      [
        -1785.0,
        -285.0,
        102.0
      ],
      [
        -1785.0,
        -285.0,
        102.0
      ],
      [
        -1800.0,
        -252.0,
        102.0
      ],
      [
        -1800.0,
        -252.0,
        102.0
      ],
      [
        -1923.0087890625,
        -148.32933044433594,
        103.0
      ],
      [
        -1897.7808837890625,
        -195.5274200439453,
        103.0
      ],
      [
        -1124.1751708984375,
        -2028.9290771484375,
        103.0
      ],
      [
        -1113.594970703125,
        -1979.6376953125,
        103.0
      ],
      [
        -1897.7808837890625,
        -195.5274200439453,
        103.0
      ],
      [
        -1882.7205810546875,
        -244.40579223632812,
        103.0
      ],
      [
        -1944.61669921875,
        -122.0,
        102.0
      ],
      [
        -1923.0087890625,
        -148.32933044433594,
        103.0
      ],
      [
        -1944.61669921875,
        -122.0,
        103.0
      ],
      [
        -1982.6666259765625,
        -270.0,
        103.0
      ],
      [
        -1960.0,
        -270.0,
        103.0
      ],
      [
        -1909.169677734375,
        -229.56898498535156,
        103.0
      ],
      [
        -1903.280517578125,
        -248.68228149414062,
        103.0
      ],
      [
        -1940.4696044921875,
        -159.99630737304688,
        103.0
      ],
      [
        -1931.041748046875,
        -177.63473510742188,
        103.0
      ],
      [
        -1982.6666259765625,
        -270.0,
        103.0
      ],
      [
        -1982.6666259765625,
        -267.4891357421875,
        103.0
      ],
      [
        -1984.250244140625,
        -267.79583740234375,
        103.0
      ],
      [
        -1982.6666259765625,
        -267.4891357421875,
        103.0
      ],
      [
        -1926.4815673828125,
        -173.3833770751953,
        103.0
      ],
      [
        -1931.783935546875,
        -176.21759033203125,
        103.0
      ],
      [
        -1926.4815673828125,
        -173.3833770751953,
        102.0
      ],
      [
        -1885.65771484375,
        -245.0167236328125,
        103.0
      ],
      [
        -1903.280517578125,
        -248.68228149414062,
        103.0
      ],
      [
        -1899.337646484375,
        -230.65042114257812,
        103.0
      ],
      [
        -1903.0242919921875,
        -218.49725341796875,
        103.0
      ],
      [
        -1923.6702880859375,
        -171.8807373046875,
        103.0
      ],
      [
        -1858.5089111328125,
        -269.0,
        102.0
      ],
      [
        -1858.5089111328125,
        -269.0,
        103.0
      ],
      [
        -1870.0,
        -269.0,
        103.0
      ],
      [
        -1800.0,
        -252.0,
        103.0
      ],
      [
        -1844.0,
        -252.0,
        103.0
      ],
      [
        -1785.0,
        -320.0,
        103.0
      ],
      [
        -1785.0,
        -285.0,
        103.0
      ],
      [
        -1800.0,
        -270.0,
        103.0
      ],
      [
        -1785.0,
        -285.0,
        103.0
      ],
      [
        -1850.0,
        -269.0,
        103.0
      ],
      [
        -1859.5,
        -252.0,
        102.0
      ],
      [
        -1859.5,
        -252.5,
        103.0
      ],
      [
        -1859.5,
        -252.0,
        103.0
      ],
      [
        -1800.0,
        -270.0,
        103.0
      ],
      [
        -1800.0,
        -252.0,
        103.0
      ],
      [
        -1850.0,
        -237.59991455078125,
        103.0
      ],
      [
        -1828.873046875,
        -233.20550537109375,
        103.0
      ],
      [
        -1859.5,
        -242.60000610351562,
        103.0
      ],
      [
        -1860.0,
        -242.60000610351562,
        103.0
      ],
      [
        -1850.0,
        -242.60000610351562,
        103.0
      ],
      [
        -1859.5,
        -242.60000610351562,
        103.0
      ],
      [
        -1859.5,
        -242.60000610351562,
        103.0
      ],
      [
        -1826.4329833984375,
        -235.63851928710938,
        103.0
      ],
      [
        -1827.2679443359375,
        -232.87161254882812,
        103.0
      ],
      [
        -1827.2679443359375,
        -232.8716278076172,
        102.0
      ],
      [
        -1832.2109375,
        -216.4913330078125,
        103.0
      ],
      [
        -1845.1197509765625,
        -173.7144775390625,
        103.0
      ],
      [
        -1839.3416748046875,
        -192.86163330078125,
        103.0
      ],
      [
        -1832.2109375,
        -216.4913330078125,
        103.0
      ],
      [
        -1834.125732421875,
        -217.06915283203125,
        103.0
      ],
      [
        -1845.1197509765625,
        -173.7144775390625,
        103.0
      ],
      [
        -1845.572509765625,
        -172.86740112304688,
        103.0
      ],
      [
        -1845.7618408203125,
        -172.5132598876953,
        102.0
      ],
      [
        -1824.0693359375,
        -200.0850067138672,
        103.0
      ],
      [
        -1823.48876953125,
        -201.99888610839844,
        103.0
      ],
      [
        -1834.6668701171875,
        -170.46710205078125,
        103.0
      ],
      [
        -1835.4322509765625,
        -168.6193389892578,
        103.0
      ],
      [
        -1825.586669921875,
        -200.54531860351562,
        103.0
      ],
      [
        -1824.0693359375,
        -200.0850067138672,
        103.0
      ],
      [
        -1836.8970947265625,
        -169.22616577148438,
        103.0
      ],
      [
        -1835.4322509765625,
        -168.6193389892578,
        103.0
      ],
      [
        -1854.5477294921875,
        -156.0760498046875,
        103.0
      ],
      [
        -1872.76171875,
        -122.0,
        102.0
      ],
      [
        -1866.18701171875,
        -134.3002471923828,
        103.0
      ],
      [
        -1872.76171875,
        -122.0,
        103.0
      ],
      [
        -1854.5477294921875,
        -156.0760498046875,
        103.0
      ],
      [
        -1856.3115234375,
        -157.0188446044922,
        103.0
      ],
      [
        -1848.881591796875,
        -140.1827850341797,
        103.0
      ],
      [
        -1849.824462890625,
        -138.41893005371094,
        103.0
      ],
      [
        -1851.222900390625,
        -139.16644287109375,
        103.0
      ],
      [
        -1849.824462890625,
        -138.41893005371094,
        103.0
      ],
      [
        -2570.0,
        -38.0,
        102.0
      ],
      [
        -2520.0,
        -38.0,
        102.0
      ],
      [
        -2572.0,
        -92.0,
        102.0
      ],
      [
        -2581.0,
        -92.0,
        102.0
      ],
      [
        -2572.0,
        -92.0,
        102.0
      ],
      [
        -2525.0,
        -92.0,
        102.0
      ],
      [
        -2570.0,
        -20.000003814697266,
        100.0
      ],
      [
        -2570.0,
        -38.0,
        102.0
      ],
      [
        -2570.0,
        -21.333337783813477,
        102.0
      ],
      [
        -2380.0,
        -23.75,
        102.0
      ],
      [
        -2390.79443359375,
        -21.333337783813477,
        102.0
      ],
      [
        -2396.75,
        -20.000003814697266,
        100.0
      ],
      [
        -1992.5,
        -23.75,
        102.0
      ],
      [
        -1994.9166259765625,
        -21.333337783813477,
        102.0
      ],
      [
        -1996.25,
        -20.000003814697266,
        100.0
      ],
      [
        -2570.0,
        -38.0,
        103.0
      ],
      [
        -2520.0,
        -38.0,
        103.0
      ],
      [
        -2572.0,
        -92.0,
        103.0
      ],
      [
        -2581.0,
        -92.0,
        103.0
      ],
      [
        -2572.0,
        -92.0,
        103.0
      ],
      [
        -2525.0,
        -92.0,
        103.0
      ],
      [
        -1875.614990234375,
        -116.66181945800781,
        103.0
      ],
      [
        -1888.3028564453125,
        -101.20161437988281,
        103.0
      ],
      [
        -1956.9598388671875,
        -106.95985412597656,
        103.0
      ],
      [
        -1875.614990234375,
        -116.66181945800781,
        103.0
      ],
      [
        -1888.3028564453125,
        -101.20161437988281,
        103.0
      ],
      [
        -1889.848876953125,
        -102.47039794921875,
        103.0
      ],
      [
        -1865.9964599609375,
        -111.43757629394531,
        103.0
      ],
      [
        -1867.1075439453125,
        -109.77464294433594,
        103.0
      ],
      [
        -1868.426025390625,
        -110.65560913085938,
        103.0
      ],
      [
        -1867.1075439453125,
        -109.77464294433594,
        103.0
      ],
      [
        -1885.8463134765625,
        -84.50834655761719,
        103.0
      ],
      [
        -1887.1151123046875,
        -82.96232604980469,
        103.0
      ],
      [
        -1888.3409423828125,
        -83.9682846069336,
        103.0
      ],
      [
        -1887.1151123046875,
        -82.96232604980469,
        103.0
      ],
      [
        -2570.0,
        -38.0,
        103.0
      ],
      [
        -2570.0,
        -22.000003814697266,
        103.0
      ],
      [
        -2380.0,
        -23.75,
        103.0
      ],
      [
        -2387.816650390625,
        -22.000003814697266,
        103.0
      ],
      [
        -1992.5,
        -23.75,
        103.0
      ],
      [
        -1994.25,
        -22.000003814697266,
        103.0
      ],
      [
        -2230.0,
        -288.0,
        352.93389892578125
      ],
      [
        -2230.0,
        -310.0,
        355.9750671386719
      ],
      [
        -2245.621337890625,
        -288.0,
        358.6688232421875
      ],
      [
        -2236.465576171875,
        -288.0,
        355.30755615234375
      ],
      [
        -2685.8134765625,
        -174.6659698486328,
        331.99896240234375
      ],
      [
        -2680.8134765625,
        -173.6656494140625,
        330.49847412109375
      ],
      [
        -2599.81982421875,
        -157.46136474609375,
        306.19207763671875
      ],
      [
        -2605.7119140625,
        -158.6402130126953,
        307.9603576660156
      ],
      [
        -2680.8134765625,
        -185.69219970703125,
        330.49847412109375
      ],
      [
        -2645.6923828125,
        -220.81336975097656,
        319.95855712890625
      ],
      [
        -2604.701171875,
        -138.43795776367188,
        277.6569519042969
      ],
      [
        -2599.81982421875,
        -157.46136474609375,
        306.19207763671875
      ],
      [
        -2680.8134765625,
        -173.6656494140625,
        330.49847412109375
      ],
      [
        -2678.0810546875,
        -171.2974090576172,
        326.94610595703125
      ],
      [
        -2659.175537109375,
        -162.66989135742188,
        314.0048828125
      ],
      [
        -2678.0810546875,
        -171.2974090576172,
        326.94610595703125
      ],
      [
        -2230.0,
        -235.99124145507812,
        270.0
      ],
      [
        -2230.0,
        -243.06231689453125,
        295.0
      ],
      [
        -2518.0,
        -43.33333969116211,
        135.0
      ],
      [
        -2570.0,
        -56.66666793823242,
        155.0
      ],
      [
        -2570.0,
        -38.0,
        127.0
      ],
      [
        -2520.0,
        -38.0,
        127.0
      ],
      [
        -2520.0,
        -92.0,
        122.85713958740234
      ],
      [
        -2520.0,
        -92.0,
        129.5500030517578
      ],
      [
        -2520.0,
        -92.0,
        129.5500030517578
      ],
      [
        -2520.0,
        -92.0,
        130.0
      ],
      [
        -2518.0,
        -92.0,
        135.0
      ],
      [
        -2520.0,
        -92.0,
        130.0
      ],
      [
        -2572.0,
        -40.666664123535156,
        131.0
      ],
      [
        -2579.5,
        -40.666664123535156,
        131.0
      ],
      [
        -2519.60009765625,
        -40.66666793823242,
        131.0
      ],
      [
        -2520.0,
        -40.0,
        130.0
      ],
      [
        -2519.60009765625,
        -92.0,
        131.0
      ],
      [
        -2573.086669921875,
        -40.0,
        130.0
      ],
      [
        -2583.138916015625,
        -39.99999237060547,
        130.0
      ],
      [
        -2525.0,
        -85.53663635253906,
        117.49983978271484
      ],
      [
        -2521.7998046875,
        -83.0,
        125.5
      ],
      [
        -2583.138916015625,
        -39.999996185302734,
        130.0
      ],
      [
        -2579.1865234375,
        -43.952392578125,
        131.0
      ],
      [
        -2582.47216796875,
        -40.666664123535156,
        131.0
      ],
      [
        -2520.0,
        -39.57143020629883,
        129.35714721679688
      ],
      [
        -2520.0,
        -38.34710693359375,
        127.52066040039062
      ],
      [
        -2520.0,
        -40.0,
        130.0
      ],
      [
        -2520.0,
        -39.57142639160156,
        129.35714721679688
      ],
      [
        -2579.5,
        -40.666664123535156,
        131.0
      ],
      [
        -2579.5,
        -55.99999237060547,
        154.0
      ],
      [
        -2579.5,
        -43.63890838623047,
        135.45835876464844
      ],
      [
        -2579.5,
        -43.63890838623047,
        131.0
      ],
      [
        -2518.0,
        -43.33333969116211,
        135.0
      ],
      [
        -2579.1865234375,
        -43.952392578125,
        135.9285888671875
      ],
      [
        -2579.1865234375,
        -58.76324462890625,
        158.14486694335938
      ],
      [
        -2579.1865234375,
        -60.59257507324219,
        158.53329467773438
      ],
      [
        -2579.1865234375,
        -59.0222053527832,
        158.53330993652344
      ],
      [
        -2570.0,
        -38.0,
        127.0
      ],
      [
        -2579.1865234375,
        -86.04759216308594,
        199.07138061523438
      ],
      [
        -2608.952392578125,
        -115.81336975097656,
        243.72006225585938
      ],
      [
        -2579.1865234375,
        -67.5,
        171.25001525878906
      ],
      [
        -2579.1865234375,
        -86.04759216308594,
        199.07138061523438
      ],
      [
        -2579.1865234375,
        -75.33333587646484,
        183.0
      ],
      [
        -2380.0,
        -23.75,
        105.62499237060547
      ],
      [
        -1111.164794921875,
        -2030.1519775390625,
        120.3877182006836
      ],
      [
        -1785.0,
        -316.0,
        135.0
      ],
      [
        -1785.0,
        -316.0,
        103.0
      ],
      [
        -2160.0,
        -380.0,
        339.9533996582031
      ],
      [
        -2138.0,
        -380.0,
        331.87689208984375
      ],
      [
        -2138.0,
        -388.4457702636719,
        333.04437255859375
      ],
      [
        -2138.0,
        -396.2794189453125,
        334.1272888183594
      ],
      [
        -2138.0,
        -380.0,
        331.87689208984375
      ],
      [
        -2138.0,
        -388.4457702636719,
        333.04437255859375
      ],
      [
        -2051.6630859375,
        -288.0,
        287.4636535644531
      ],
      [
        -2037.984130859375,
        -288.0,
        282.4418640136719
      ],
      [
        -2058.17041015625,
        -288.0,
        289.8525695800781
      ],
      [
        -2070.0,
        -288.0,
        294.19537353515625
      ],
      [
        -1946.00537109375,
        -270.0,
        185.48802185058594
      ],
      [
        -1999.1798095703125,
        -270.0,
        186.69786071777344
      ],
      [
        -2003.499267578125,
        -270.0,
        200.0
      ],
      [
        -1800.0,
        -269.0,
        116.0
      ],
      [
        -1800.0,
        -269.0,
        103.0
      ],
      [
        -1859.5,
        -252.0,
        110.0
      ],
      [
        -1859.5,
        -252.0,
        103.0
      ],
      [
        -1859.5,
        -243.63369750976562,
        110.0
      ],
      [
        -1859.5,
        -243.63369750976562,
        103.0
      ],
      [
        -1851.58154296875,
        -242.10000610351562,
        110.0
      ],
      [
        -1851.58154296875,
        -242.10000610351562,
        115.0
      ],
      [
        -1854.1629638671875,
        -242.60000610351562,
        105.0
      ],
      [
        -1854.1629638671875,
        -242.60000610351562,
        103.0
      ],
      [
        -1976.89501953125,
        -51.333335876464844,
        147.0
      ],
      [
        -1899.46728515625,
        -46.0,
        139.0
      ],
      [
        -1993.7381591796875,
        -268.9176025390625,
        168.5591278076172
      ],
      [
        -2005.766357421875,
        -240.25466918945312,
        169.0384063720703
      ],
      [
        -2017.527587890625,
        -211.48477172851562,
        168.55914306640625
      ],
      [
        -1940.4696044921875,
        -159.99630737304688,
        109.20000457763672
      ],
      [
        -1939.6614990234375,
        -161.50814819335938,
        109.20000457763672
      ],
      [
        -1939.6614990234375,
        -161.50814819335938,
        109.20000457763672
      ],
      [
        -1917.990478515625,
        -202.05194091796875,
        109.20000457763672
      ],
      [
        -1894.0877685546875,
        -246.7701873779297,
        127.30290985107422
      ],
      [
        -1903.280517578125,
        -248.68228149414062,
        109.26610565185547
      ],
      [
        -1894.0880126953125,
        -246.77023315429688,
        110.20138549804688
      ],
      [
        -1903.67529296875,
        -247.4008026123047,
        109.26533508300781
      ],
      [
        -1903.280517578125,
        -248.68228149414062,
        109.26610565185547
      ],
      [
        -1926.6949462890625,
        -32.66666793823242,
        119.0
      ],
      [
        -1903.5289306640625,
        -42.66666793823242,
        134.0
      ],
      [
        -1850.0,
        -237.59991455078125,
        114.68711853027344
      ],
      [
        -1828.873046875,
        -233.20550537109375,
        116.83668518066406
      ],
      [
        -1885.65771484375,
        -245.0167236328125,
        111.05911254882812
      ],
      [
        -1851.58154296875,
        -242.10000610351562,
        114.40570068359375
      ],
      [
        -1860.851806640625,
        -242.10000610351562,
        113.51822662353516
      ],
      [
        -1903.5289306640625,
        -42.66666793823242,
        134.0
      ],
      [
        -1899.46728515625,
        -46.0,
        139.0
      ],
      [
        -1861.3236083984375,
        -107.11361694335938,
        118.71874237060547
      ],
      [
        -1829.2408447265625,
        -167.13636779785156,
        118.71874237060547
      ],
      [
        -1826.4329833984375,
        -235.63851928710938,
        116.99061584472656
      ],
      [
        -1826.446533203125,
        -235.5936279296875,
        116.9906234741211
      ],
      [
        -1826.446533203125,
        -235.5936279296875,
        116.9906234741211
      ],
      [
        -1850.0,
        -237.59991455078125,
        114.66724395751953
      ],
      [
        -1828.873046875,
        -233.20550537109375,
        116.82693481445312
      ],
      [
        -1885.65771484375,
        -245.0167236328125,
        111.02218627929688
      ],
      [
        -1903.280517578125,
        -248.68228149414062,
        109.22071075439453
      ],
      [
        -1851.58154296875,
        -242.10000610351562,
        114.38392639160156
      ],
      [
        -1860.8492431640625,
        -242.10000610351562,
        113.49276733398438
      ],
      [
        -1903.7515869140625,
        -247.1532745361328,
        109.22000885009766
      ],
      [
        -1903.280517578125,
        -248.68228149414062,
        109.22071075439453
      ],
      [
        -1826.4329833984375,
        -235.63851928710938,
        115.72281646728516
      ],
      [
        -1828.112060546875,
        -230.07421875,
        115.83757781982422
      ],
      [
        -1828.112060546875,
        -230.07421875,
        115.83757781982422
      ],
      [
        -1850.0,
        -237.59991455078125,
        113.54142761230469
      ],
      [
        -1828.873046875,
        -233.20550537109375,
        115.621826171875
      ],
      [
        -1885.65771484375,
        -245.0167236328125,
        110.0301513671875
      ],
      [
        -1903.280517578125,
        -248.68228149414062,
        108.29483795166016
      ],
      [
        -1851.58154296875,
        -242.10000610351562,
        113.18810272216797
      ],
      [
        -1860.7376708984375,
        -242.10000610351562,
        112.37670135498047
      ],
      [
        -1905.108154296875,
        -242.7508087158203,
        108.4138412475586
      ],
      [
        -1903.280517578125,
        -248.68228149414062,
        108.29483795166016
      ],
      [
        -1821.0987548828125,
        -199.18392944335938,
        117.92227172851562
      ],
      [
        -1818.244873046875,
        -198.31820678710938,
        118.2161865234375
      ],
      [
        -1818.244873046875,
        -198.31820678710938,
        118.2161865234375
      ],
      [
        -1817.679931640625,
        -200.23683166503906,
        118.1753921508789
      ],
      [
        -1828.8616943359375,
        -168.0625457763672,
        118.70845794677734
      ],
      [
        -1912.9913330078125,
        -71.11873626708984,
        115.84503936767578
      ],
      [
        -1864.4002685546875,
        -107.96565246582031,
        118.4057388305664
      ],
      [
        -1861.883056640625,
        -106.28377532958984,
        118.70849609375
      ],
      [
        -1861.883056640625,
        -106.28378295898438,
        118.70845794677734
      ],
      [
        -1884.7254638671875,
        -81.00112915039062,
        117.88179779052734
      ],
      [
        -1882.4228515625,
        -79.11146545410156,
        118.17537689208984
      ],
      [
        -1881.141357421875,
        -80.64713287353516,
        118.2161865234375
      ],
      [
        -1882.4228515625,
        -79.11146545410156,
        118.17537689208984
      ],
      [
        -1903.280517578125,
        -248.68228149414062,
        106.0
      ],
      [
        -1940.4696044921875,
        -159.99630737304688,
        106.0
      ],
      [
        -1926.4815673828125,
        -173.3833770751953,
        106.0
      ],
      [
        -1931.783935546875,
        -176.21759033203125,
        106.0
      ],
      [
        -1926.4815673828125,
        -173.3833770751953,
        103.0
      ],
      [
        -1885.65771484375,
        -245.0167236328125,
        106.0
      ],
      [
        -1903.280517578125,
        -248.68228149414062,
        106.0
      ],
      [
        -1899.337646484375,
        -230.65042114257812,
        106.0
      ],
      [
        -1903.0242919921875,
        -218.49725341796875,
        106.0
      ],
      [
        -1923.6702880859375,
        -171.8807373046875,
        106.0
      ],
      [
        -1894.088134765625,
        -246.770263671875,
        109.20001220703125
      ],
      [
        -1894.088134765625,
        -246.770263671875,
        106.0
      ],
      [
        -1992.5,
        -23.75,
        105.62499237060547
      ],
      [
        -1832.2109375,
        -216.4913330078125,
        106.0
      ],
      [
        -1834.125732421875,
        -217.06915283203125,
        106.0
      ],
      [
        -1848.794677734375,
        -140.13629150390625,
        103.24654388427734
      ],
      [
        -1849.7374267578125,
        -138.3724365234375,
        103.24657440185547
      ],
      [
        -1849.8385009765625,
        -138.42642211914062,
        103.0
      ],
      [
        -1849.7374267578125,
        -138.3724365234375,
        103.24657440185547
      ],
      [
        -1823.97412109375,
        -200.05613708496094,
        103.2486343383789
      ],
      [
        -1823.3935546875,
        -201.9700164794922,
        103.24867248535156
      ],
      [
        -1824.084716796875,
        -200.08966064453125,
        103.0
      ],
      [
        -1823.97412109375,
        -200.05613708496094,
        103.24864196777344
      ],
      [
        -1885.7694091796875,
        -84.44525146484375,
        103.2486343383789
      ],
      [
        -1887.03759765625,
        -82.89871215820312,
        103.25068664550781
      ],
      [
        -1887.1275634765625,
        -82.97257232666016,
        103.0
      ],
      [
        -1887.03759765625,
        -82.89871215820312,
        103.25068664550781
      ],
      [
        -2011.713134765625,
        -226.0835723876953,
        169.27537536621094
      ],
      [
        -1994.5859375,
        -269.08624267578125,
        171.38514709472656
      ],
      [
        -2138.0,
        -203.3455810546875,
        307.4571228027344
      ],
      [
        -2138.0,
        -192.11070251464844,
        305.904052734375
      ],
      [
        -2138.0,
        -203.3455810546875,
        307.4571228027344
      ],
      [
        -2138.0,
        -209.35226440429688,
        308.2874450683594
      ],
      [
        -2138.0,
        -220.0,
        309.7593078613281
      ],
      [
        -2138.0,
        -209.35226440429688,
        308.2874450683594
      ],
      [
        -2138.0,
        -198.17042541503906,
        270.0
      ],
      [
        -2138.0,
        -203.17042541503906,
        295.0
      ],
      [
        -2066.53369140625,
        -244.2296600341797,
        286.8723449707031
      ],
      [
        -2094.997802734375,
        -217.68331909179688,
        293.6522216796875
      ],
      [
        -2094.997802734375,
        -217.68331909179688,
        293.6522216796875
      ],
      [
        -2099.21728515625,
        -216.22732543945312,
        295.0
      ],
      [
        -2160.0,
        -191.04290771484375,
        313.8330078125
      ],
      [
        -2138.0,
        -188.3159637451172,
        305.3794860839844
      ],
      [
        -2138.0,
        -188.3159637451172,
        305.3794860839844
      ],
      [
        -2637.32568359375,
        -144.1866455078125,
        317.4476623535156
      ],
      [
        -2642.32568359375,
        -149.1866455078125,
        318.9482116699219
      ],
      [
        -2627.32568359375,
        -134.1866455078125,
        284.4466247558594
      ],
      [
        -2651.468017578125,
        -144.1866455078125,
        321.6918029785156
      ],
      [
        -2627.32568359375,
        -134.1866455078125,
        277.3454284667969
      ],
      [
        -2627.32568359375,
        -134.1866455078125,
        284.4466247558594
      ],
      [
        -2658.35546875,
        -152.75741577148438,
        320.1879577636719
      ],
      [
        -2675.900634765625,
        -170.30235290527344,
        325.4535217285156
      ],
      [
        -2680.8134765625,
        -173.53219604492188,
        330.49847412109375
      ],
      [
        -2680.418701171875,
        -173.323486328125,
        329.9852294921875
      ],
      [
        -2680.8134765625,
        -65.6922607421875,
        330.49847412109375
      ],
      [
        -2645.6923828125,
        -100.81336975097656,
        319.95855712890625
      ],
      [
        -2579.5,
        -43.63890075683594,
        135.45835876464844
      ],
      [
        -2579.5,
        -43.63885498046875,
        154.0
      ],
      [
        -2637.32568359375,
        -144.1866455078125,
        317.4476623535156
      ],
      [
        -2567.192138671875,
        -55.94671630859375,
        153.92007446289062
      ],
      [
        -2570.0,
        -53.1389045715332,
        155.0
      ],
      [
        -2579.5,
        -39.999996185302734,
        130.0
      ],
      [
        -2585.138916015625,
        -38.0,
        130.0
      ],
      [
        -2579.5,
        -38.0,
        130.0
      ],
      [
        -2570.0,
        -14.18667221069336,
        130.0
      ],
      [
        -2570.0,
        -14.186673164367676,
        100.0
      ],
      [
        -2570.0,
        -14.186673164367676,
        130.0
      ],
      [
        -2859.0,
        13.75,
        100.0
      ],
      [
        -2859.0,
        13.75,
        126.0
      ],
      [
        -2547.5,
        13.75,
        100.0
      ],
      [
        -2547.5,
        13.75,
        126.0
      ],
      [
        -2104.563720703125,
        13.75,
        100.0
      ],
      [
        -2104.563720703125,
        13.75,
        196.0
      ],
      [
        -2030.0,
        13.75,
        125.0
      ],
      [
        -2030.0,
        13.75,
        100.0
      ],
      [
        -2094.563720703125,
        13.75,
        234.0
      ],
      [
        -2094.563720703125,
        13.75,
        253.0
      ],
      [
        -2111.96484375,
        161.25,
        125.0
      ],
      [
        -2111.96484375,
        161.25,
        100.0
      ],
      [
        -2237.5,
        161.25,
        100.0
      ],
      [
        -2237.5,
        161.25,
        126.0
      ],
      [
        -2238.75,
        162.5,
        100.0
      ],
      [
        -2238.75,
        162.5,
        126.0
      ],
      [
        -2237.5,
        196.25,
        100.0
      ],
      [
        -2237.5,
        196.25,
        126.0
      ],
      [
        -2487.5859375,
        489.5000305175781,
        135.0
      ],
      [
        -2490.0,
        490.0,
        133.33343505859375
      ],
      [
        -1923.1798095703125,
        340.0,
        100.0
      ],
      [
        -1923.1798095703125,
        340.0,
        126.0
      ],
      [
        -1923.1798095703125,
        340.0,
        126.0
      ],
      [
        -1924.5,
        338.7499084472656,
        126.0
      ],
      [
        -1845.12060546875,
        338.75,
        125.0
      ],
      [
        -1777.0220947265625,
        338.75,
        100.0
      ],
      [
        -2104.563720703125,
        45.550559997558594,
        234.0
      ],
      [
        -2104.563720703125,
        45.550559997558594,
        253.0
      ],
      [
        -2104.563720703125,
        161.25,
        125.0
      ],
      [
        -2104.563720703125,
        161.25,
        100.0
      ],
      [
        -1922.0,
        338.75,
        100.0
      ],
      [
        -1922.0,
        338.75,
        126.0
      ],
      [
        -1922.0,
        338.75,
        126.0
      ],
      [
        -565.42431640625,
        -1336.6162109375,
        -113.20274353027344
      ],
      [
        -157.67498779296875,
        -1068.1884765625,
        -300.0
      ],
      [
        -1074.1181640625,
        -2033.634033203125,
        169.8988800048828
      ],
      [
        -1121.50390625,
        -1650.1837158203125,
        0.0
      ],
      [
        -1059.9925537109375,
        -1650.0186767578125,
        80.53497314453125
      ],
      [
        -1044.6822509765625,
        -1688.2943115234375,
        111.35455322265625
      ],
      [
        -1044.6822509765625,
        -1688.2943115234375,
        111.35456085205078
      ],
      [
        -1059.9925537109375,
        -1650.0186767578125,
        80.53498077392578
      ],
      [
        -950.483154296875,
        -1590.1065673828125,
        63.19963836669922
      ],
      [
        -1121.50390625,
        -1650.1837158203125,
        0.0
      ],
      [
        -1127.150390625,
        -1645.765380859375,
        -19.344146728515625
      ],
      [
        -826.8541259765625,
        -1461.2427978515625,
        0.0
      ],
      [
        -565.42431640625,
        -1336.6162109375,
        -113.20272827148438
      ],
      [
        -826.8541259765625,
        -1461.2427978515625,
        0.0
      ],
      [
        4526.4208984375,
        -1556.87548828125,
        543.49267578125
      ],
      [
        -1145.6080322265625,
        -2059.143798828125,
        251.769287109375
      ],
      [
        -158.70803833007812,
        -3106.798095703125,
        670.1329345703125
      ],
      [
        334.5896301269531,
        -3672.376220703125,
        892.7235107421875
      ],
      [
        -158.70806884765625,
        -3106.79833984375,
        670.1329956054688
      ],
      [
        -1527.4627685546875,
        -2745.952392578125,
        440.9891357421875
      ],
      [
        -1174.739013671875,
        -2184.3720703125,
        289.6177673339844
      ],
      [
        -1174.739013671875,
        -2184.3720703125,
        289.6177978515625
      ],
      [
        -1145.6080322265625,
        -2059.143798828125,
        251.769287109375
      ],
      [
        -1549.2021484375,
        -2765.516357421875,
        445.481201171875
      ],
      [
        -1527.4627685546875,
        -2745.9521484375,
        440.989013671875
      ],
      [
        2854.1552734375,
        -1223.3333740234375,
        305.0291748046875
      ],
      [
        2861.488525390625,
        -698.838623046875,
        -293.53936767578125
      ],
      [
        2859.015625,
        -796.68505859375,
        6.103515625e-05
      ],
      [
        1763.2515869140625,
        -927.0469970703125,
        81.9367904663086
      ],
      [
        1763.8328857421875,
        -818.5941162109375,
        5.1944966316223145
      ],
      [
        -794.8798828125,
        -1446.0003662109375,
        -13.845283508300781
      ],
      [
        -504.59906005859375,
        -1467.1614990234375,
        114.45516204833984
      ],
      [
        -1018.4613037109375,
        -1753.8465576171875,
        164.13726806640625
      ],
      [
        -681.8505859375,
        -1625.7083740234375,
        150.7703399658203
      ],
      [
        -1009.0797729492188,
        -2039.7471923828125,
        256.8197326660156
      ],
      [
        -1018.4613037109375,
        -1753.8466796875,
        164.1372833251953
      ],
      [
        -504.59906005859375,
        -1467.1614990234375,
        114.45515441894531
      ],
      [
        -681.8506469726562,
        -1625.7083740234375,
        150.77035522460938
      ],
      [
        1763.1832275390625,
        -927.0469360351562,
        93.2012710571289
      ],
      [
        1763.848388671875,
        -803.9506225585938,
        5.1944966316223145
      ],
      [
        -1143.6485595703125,
        -2061.22412109375,
        252.5999755859375
      ],
      [
        -236.0840606689453,
        -3010.201904296875,
        790.0325927734375
      ],
      [
        353.0361328125,
        -3680.16650390625,
        1163.4200439453125
      ],
      [
        -236.08407592773438,
        -3010.2021484375,
        790.0326538085938
      ],
      [
        -1492.434326171875,
        -2760.922119140625,
        529.8773803710938
      ],
      [
        -1172.828125,
        -2196.1005859375,
        310.4969177246094
      ],
      [
        -1939.5809326171875,
        -3110.410400390625,
        636.4718627929688
      ],
      [
        -1648.24072265625,
        -2909.402099609375,
        579.1571044921875
      ],
      [
        -1648.24072265625,
        -2909.402099609375,
        579.1570434570312
      ],
      [
        -1492.434326171875,
        -2760.921875,
        529.8772583007812
      ],
      [
        -1172.828125,
        -2196.100341796875,
        310.4968566894531
      ],
      [
        -1146.2474365234375,
        -2061.892333984375,
        252.59999084472656
      ],
      [
        -1007.595458984375,
        -2039.88671875,
        258.803466796875
      ],
      [
        -1009.5068969726562,
        -2026.73095703125,
        252.60015869140625
      ],
      [
        1019.587158203125,
        -1695.0367431640625,
        431.56463623046875
      ],
      [
        -1088.6651611328125,
        -2097.481689453125,
        509.45013427734375
      ],
      [
        -317.6634521484375,
        -2908.3583984375,
        916.4456787109375
      ],
      [
        362.54669189453125,
        -3684.182861328125,
        1302.9847412109375
      ],
      [
        -317.66339111328125,
        -2908.358642578125,
        916.4456176757812
      ],
      [
        -2101.2802734375,
        -3399.51513671875,
        1050.8297119140625
      ],
      [
        -2144.1455078125,
        -3408.1083984375,
        1052.5999755859375
      ],
      [
        -1378.6275634765625,
        -2809.558349609375,
        818.6738891601562
      ],
      [
        -1143.2017822265625,
        -2377.942626953125,
        634.2150268554688
      ],
      [
        -2099.20068359375,
        -3398.540283203125,
        1050.490234375
      ],
      [
        -1617.5257568359375,
        -3047.155029296875,
        914.7691650390625
      ],
      [
        -2099.20068359375,
        -3398.540283203125,
        1050.490234375
      ],
      [
        -2101.2802734375,
        -3399.51513671875,
        1050.8297119140625
      ],
      [
        -1617.5257568359375,
        -3047.155029296875,
        914.7692260742188
      ],
      [
        -1378.6275634765625,
        -2809.55810546875,
        818.673828125
      ],
      [
        -1143.2017822265625,
        -2377.942626953125,
        634.215087890625
      ],
      [
        -1088.6651611328125,
        -2097.481689453125,
        509.4501037597656
      ],
      [
        544.5404052734375,
        -1746.0208740234375,
        431.07000732421875
      ],
      [
        -52.859100341796875,
        -1691.1807861328125,
        376.37713623046875
      ],
      [
        -436.7973327636719,
        -1689.80029296875,
        356.619873046875
      ],
      [
        -778.3905029296875,
        -2110.8046875,
        530.965576171875
      ],
      [
        -614.9921264648438,
        -1565.9052734375,
        137.07241821289062
      ],
      [
        -1012.9479370117188,
        -1921.8660888671875,
        218.60536193847656
      ],
      [
        544.5404663085938,
        -1746.0208740234375,
        431.07000732421875
      ],
      [
        1019.5870971679688,
        -1695.0367431640625,
        431.56463623046875
      ],
      [
        -411.225341796875,
        -1658.283447265625,
        343.5681457519531
      ],
      [
        -411.225341796875,
        -1658.283447265625,
        343.56817626953125
      ],
      [
        2400.0,
        -1844.385986328125,
        749.0462646484375
      ],
      [
        4526.4208984375,
        -1556.87548828125,
        543.49267578125
      ],
      [
        85.42315673828125,
        -3334.0634765625,
        1814.080322265625
      ],
      [
        -560.6012573242188,
        -2605.0751953125,
        1292.895263671875
      ],
      [
        -1025.829345703125,
        -2139.787109375,
        793.7977294921875
      ],
      [
        -560.601318359375,
        -2605.074951171875,
        1292.895263671875
      ],
      [
        -869.4028930664062,
        -2286.437255859375,
        1065.087646484375
      ],
      [
        -4123.98779296875,
        -2759.122802734375,
        1403.0306396484375
      ],
      [
        -4131.109375,
        -2740.787109375,
        1389.9215087890625
      ],
      [
        -1100.671875,
        -2928.344970703125,
        1524.014892578125
      ],
      [
        -1067.298095703125,
        -2843.8271484375,
        1463.5894775390625
      ],
      [
        -1067.298095703125,
        -2843.8271484375,
        1463.5894775390625
      ],
      [
        -1025.829345703125,
        -2139.787353515625,
        793.7976684570312
      ],
      [
        -1001.381103515625,
        -2304.28173828125,
        1077.845458984375
      ],
      [
        -1100.671875,
        -2928.344970703125,
        1524.014892578125
      ],
      [
        -1247.748291015625,
        -3108.19873046875,
        1652.5999755859375
      ],
      [
        -3557.677978515625,
        -2549.120361328125,
        1152.9107666015625
      ],
      [
        -3528.30859375,
        -2586.1181640625,
        1220.0
      ],
      [
        -2988.559814453125,
        -3223.927001953125,
        1037.2603759765625
      ],
      [
        191.95574951171875,
        -2234.215087890625,
        1027.7518310546875
      ],
      [
        360.59326171875,
        -2000.717041015625,
        742.3652954101562
      ],
      [
        1109.864501953125,
        -2018.8233642578125,
        873.759033203125
      ],
      [
        -166.50149536132812,
        -2318.328857421875,
        1087.8883056640625
      ],
      [
        -193.138916015625,
        -2403.4306640625,
        1148.731201171875
      ],
      [
        -609.42333984375,
        -1902.55712890625,
        444.7264404296875
      ],
      [
        -476.1239929199219,
        -1980.4971923828125,
        595.6363525390625
      ],
      [
        -164.9033203125,
        -2162.4677734375,
        947.973388671875
      ],
      [
        -136.1424102783203,
        -2221.3369140625,
        1018.5446166992188
      ],
      [
        -136.14242553710938,
        -2221.3369140625,
        1018.5445556640625
      ],
      [
        -164.90333557128906,
        -2162.4677734375,
        947.973388671875
      ],
      [
        360.59344482421875,
        -2000.7166748046875,
        742.3648681640625
      ],
      [
        191.9557342529297,
        -2234.215087890625,
        1027.7518310546875
      ],
      [
        1721.03564453125,
        -1875.4091796875,
        771.22607421875
      ],
      [
        2400.0,
        -1844.385986328125,
        749.0462646484375
      ],
      [
        1721.03564453125,
        -1875.4091796875,
        771.22607421875
      ],
      [
        -476.1240234375,
        -1980.4971923828125,
        595.6363525390625
      ],
      [
        -580.3717041015625,
        -1866.7518310546875,
        429.8988037109375
      ],
      [
        -374.75189208984375,
        -1732.9390869140625,
        433.0637512207031
      ],
      [
        -52.859130859375,
        -1691.1807861328125,
        376.37713623046875
      ],
      [
        -374.75189208984375,
        -1732.9390869140625,
        433.06378173828125
      ],
      [
        -436.7973327636719,
        -1689.80029296875,
        356.619873046875
      ],
      [
        -987.384765625,
        -2165.6708984375,
        967.7686157226562
      ],
      [
        -963.984130859375,
        -2188.843505859375,
        995.3135986328125
      ],
      [
        -987.384765625,
        -2165.6708984375,
        967.7688598632812
      ],
      [
        -987.1666259765625,
        -2187.933349609375,
        994.6629028320312
      ],
      [
        -3652.813720703125,
        -2436.3173828125,
        1172.2432861328125
      ],
      [
        -3597.956298828125,
        -2503.115234375,
        1220.0
      ],
      [
        -984.6701049804688,
        -2167.49853515625,
        980.05322265625
      ],
      [
        -984.6701049804688,
        -2167.49853515625,
        980.05322265625
      ],
      [
        6992.10546875,
        -1390.916015625,
        590.90966796875
      ],
      [
        1109.865478515625,
        -2018.8232421875,
        873.7589111328125
      ],
      [
        -233.89080810546875,
        -2962.61669921875,
        1774.980712890625
      ],
      [
        -556.1375122070312,
        -2604.275390625,
        1411.1329345703125
      ],
      [
        -596.04345703125,
        -2560.829345703125,
        1347.8155517578125
      ],
      [
        -1027.7886962890625,
        -2520.433837890625,
        1232.3817138671875
      ],
      [
        -1020.4502563476562,
        -2691.334228515625,
        1460.001953125
      ],
      [
        -1033.012451171875,
        -2899.037353515625,
        1656.375
      ],
      [
        -713.9907836914062,
        -2446.799560546875,
        1179.737548828125
      ],
      [
        -596.0433349609375,
        -2560.8291015625,
        1347.8153076171875
      ],
      [
        -166.50149536132812,
        -2318.328857421875,
        1087.8883056640625
      ],
      [
        -1001.381103515625,
        -2304.281982421875,
        1077.8455810546875
      ],
      [
        -998.296142578125,
        -2325.03857421875,
        1113.6878662109375
      ],
      [
        -869.4028930664062,
        -2286.437255859375,
        1065.087646484375
      ],
      [
        -602.860107421875,
        -2552.319091796875,
        1358.37841796875
      ],
      [
        -841.74365234375,
        -2312.367919921875,
        1113.0570068359375
      ],
      [
        -602.8601684570312,
        -2552.3193359375,
        1358.3785400390625
      ],
      [
        -987.4636840820312,
        -2397.92236328125,
        1239.5428466796875
      ],
      [
        -1014.552978515625,
        -2843.658935546875,
        1660.47705078125
      ],
      [
        -274.495849609375,
        -2915.38232421875,
        1770.0086669921875
      ],
      [
        -620.4629516601562,
        -2530.343994140625,
        1385.6552734375
      ],
      [
        -620.462890625,
        -2530.34375,
        1385.6551513671875
      ],
      [
        -773.8843994140625,
        -2375.986083984375,
        1230.7449951171875
      ],
      [
        -4125.63623046875,
        -2756.2802734375,
        1402.974609375
      ],
      [
        -4128.15283203125,
        -2748.399658203125,
        1395.3641357421875
      ],
      [
        6992.103515625,
        -1390.916015625,
        590.90966796875
      ],
      [
        3366.189697265625,
        -1334.87353515625,
        384.7739562988281
      ],
      [
        -973.9005126953125,
        -2174.74951171875,
        1028.7882080078125
      ],
      [
        -973.9005126953125,
        -2174.74951171875,
        1028.7882080078125
      ],
      [
        2962.535400390625,
        -1257.6370849609375,
        329.5543518066406
      ],
      [
        2455.532470703125,
        -1160.625732421875,
        260.1967468261719
      ],
      [
        2621.07421875,
        -1158.5028076171875,
        267.47998046875
      ],
      [
        2854.1337890625,
        -1223.333251953125,
        308.560546875
      ],
      [
        2855.32861328125,
        -1120.3388671875,
        231.39405822753906
      ],
      [
        2854.681640625,
        -1167.4876708984375,
        283.2035217285156
      ],
      [
        2853.9306640625,
        -1223.331787109375,
        341.997802734375
      ],
      [
        2854.1474609375,
        -1206.4012451171875,
        325.96368408203125
      ],
      [
        -903.2229614257812,
        -2222.334716796875,
        1348.62158203125
      ],
      [
        -909.1630249023438,
        -2527.489013671875,
        1683.8970947265625
      ],
      [
        -575.9976196289062,
        -2564.65576171875,
        1733.090087890625
      ],
      [
        -725.1876220703125,
        -2399.605712890625,
        1547.93359375
      ],
      [
        -903.2229614257812,
        -2222.334716796875,
        1348.62158203125
      ],
      [
        -725.1875610351562,
        -2399.605712890625,
        1547.9334716796875
      ],
      [
        2853.9150390625,
        -1223.3316650390625,
        344.5677490234375
      ],
      [
        -3749.496337890625,
        -2237.32958984375,
        1293.859130859375
      ],
      [
        -3766.849609375,
        -2126.165771484375,
        1171.234130859375
      ],
      [
        -3725.157958984375,
        -2329.201904296875,
        1299.860595703125
      ],
      [
        -3714.01416015625,
        -2323.6279296875,
        1179.1334228515625
      ],
      [
        -3697.798095703125,
        -2384.52392578125,
        1182.3121337890625
      ],
      [
        -3697.73974609375,
        -2384.451171875,
        1181.5667724609375
      ],
      [
        -3697.797607421875,
        -2384.524658203125,
        1182.310546875
      ],
      [
        -3702.450439453125,
        -2378.30322265625,
        1210.55859375
      ],
      [
        -3702.450439453125,
        -2378.30322265625,
        1210.55859375
      ],
      [
        -3703.801513671875,
        -2376.973876953125,
        1220.0
      ],
      [
        -4022.8212890625,
        -1204.943603515625,
        1224.7767333984375
      ],
      [
        -4021.5146484375,
        -1174.40478515625,
        1133.1591796875
      ],
      [
        2853.790771484375,
        -1003.4161376953125,
        620.193359375
      ],
      [
        1762.6253662109375,
        -862.1466064453125,
        196.3846893310547
      ],
      [
        1763.854248046875,
        -798.4165649414062,
        5.1944966316223145
      ],
      [
        235.99966430664062,
        5035.24365234375,
        -36.837890625
      ],
      [
        -3988.779052734375,
        5850.89794921875,
        150.0
      ],
      [
        -1146.684326171875,
        5724.8427734375,
        150.0
      ],
      [
        259.23272705078125,
        5158.08642578125,
        0.0
      ],
      [
        235.99966430664062,
        5035.24365234375,
        -36.837890625
      ],
      [
        588.0418701171875,
        7262.134765625,
        150.0
      ],
      [
        445.29931640625,
        5654.2333984375,
        150.0
      ],
      [
        -1857.3211669921875,
        6954.4736328125,
        506.298583984375
      ],
      [
        -1146.6842041015625,
        5724.8427734375,
        150.0
      ],
      [
        3966.75,
        4947.60009765625,
        -13.693603515625
      ],
      [
        3956.6728515625,
        4948.55078125,
        -13.543867111206055
      ],
      [
        3020.6171875,
        6729.98193359375,
        570.58251953125
      ],
      [
        2769.303955078125,
        7185.4150390625,
        710.5693969726562
      ],
      [
        3020.6171875,
        6729.98193359375,
        570.58251953125
      ],
      [
        3955.45556640625,
        4948.66552734375,
        -13.525781631469727
      ],
      [
        3038.7060546875,
        5480.240234375,
        150.0
      ],
      [
        3720.545654296875,
        5419.32177734375,
        150.0
      ],
      [
        3923.18212890625,
        5039.8720703125,
        28.237018585205078
      ],
      [
        3038.7060546875,
        5480.24072265625,
        150.0
      ],
      [
        2532.767578125,
        5561.64794921875,
        150.00003051757812
      ],
      [
        1829.323974609375,
        813.152587890625,
        23.481231689453125
      ],
      [
        895.1297607421875,
        2990.796142578125,
        60.0
      ],
      [
        1781.190673828125,
        916.6904296875,
        60.0
      ],
      [
        2864.146728515625,
        -321.70458984375,
        -293.53936767578125
      ],
      [
        2869.538330078125,
        748.0042724609375,
        60.0
      ],
      [
        2867.79736328125,
        500.97760009765625,
        60.0
      ],
      [
        4302.4873046875,
        4148.26171875,
        60.0
      ],
      [
        4043.42919921875,
        4957.79150390625,
        60.0
      ],
      [
        -2657.889892578125,
        3369.26904296875,
        60.0
      ],
      [
        -1255.4737548828125,
        3519.528076171875,
        60.0
      ],
      [
        -800.0,
        3733.86865234375,
        60.0
      ],
      [
        -700.0,
        3780.927490234375,
        60.000003814697266
      ],
      [
        -1255.4737548828125,
        3519.528076171875,
        60.0
      ],
      [
        -417.7394104003906,
        3913.755859375,
        60.0
      ],
      [
        896.0,
        2404.0,
        60.0
      ],
      [
        896.0,
        2704.0,
        60.0
      ],
      [
        -1677.351806640625,
        2100.0,
        0.0
      ],
      [
        -1839.6396484375,
        2089.6396484375,
        -31.0811824798584
      ],
      [
        -1839.6396484375,
        2089.6396484375,
        -31.0811767578125
      ],
      [
        -1815.5555419921875,
        1912.0106201171875,
        -103.33317565917969
      ],
      [
        -1677.351806640625,
        2100.0,
        0.0
      ],
      [
        -1537.6434326171875,
        2100.0,
        22.930442810058594
      ],
      [
        110.923095703125,
        1482.019287109375,
        28.39008331298828
      ],
      [
        -87.2385025024414,
        1937.9737548828125,
        60.0
      ],
      [
        69.25993347167969,
        1571.6395263671875,
        60.0
      ],
      [
        62.046356201171875,
        1660.695556640625,
        -228.5707244873047
      ],
      [
        55.53363800048828,
        1693.8050537109375,
        -300.0
      ],
      [
        -712.9918212890625,
        1315.3206787109375,
        -178.3552703857422
      ],
      [
        -616.7625732421875,
        1534.800537109375,
        -68.40165710449219
      ],
      [
        -716.4713745117188,
        1241.915283203125,
        -210.41819763183594
      ],
      [
        -712.9918212890625,
        1315.3206787109375,
        -178.35525512695312
      ],
      [
        -723.296875,
        1097.9208984375,
        -273.31365966796875
      ],
      [
        -716.4713745117188,
        1241.915283203125,
        -210.418212890625
      ],
      [
        -690.8482055664062,
        1023.302490234375,
        -300.0
      ],
      [
        -723.296875,
        1097.9208984375,
        -273.31365966796875
      ],
      [
        -1530.0,
        2100.0,
        24.184972763061523
      ],
      [
        886.9979858398438,
        2987.322265625,
        150.0
      ],
      [
        1662.56689453125,
        1171.85791015625,
        150.0
      ],
      [
        4399.7919921875,
        4196.43994140625,
        150.0
      ],
      [
        4153.3125,
        4966.6630859375,
        150.0
      ],
      [
        2868.99169921875,
        748.0081176757812,
        150.0
      ],
      [
        2868.726806640625,
        710.4066162109375,
        150.0
      ],
      [
        -95.37027740478516,
        1934.499755859375,
        150.0
      ],
      [
        -49.363739013671875,
        1826.806884765625,
        150.0
      ],
      [
        -2975.755615234375,
        3160.571044921875,
        150.0
      ],
      [
        829.919189453125,
        2962.938232421875,
        781.7308349609375
      ],
      [
        2868.8935546875,
        748.0087890625,
        166.15914916992188
      ],
      [
        -2982.13916015625,
        3224.859619140625,
        268.421875
      ],
      [
        -3086.993408203125,
        3102.758056640625,
        198.8289794921875
      ],
      [
        -98.75617980957031,
        1933.0533447265625,
        187.47412109375
      ],
      [
        1933.5692138671875,
        560.0,
        60.0
      ],
      [
        1847.671875,
        761.0700073242188,
        60.0
      ],
      [
        636.4490356445312,
        243.9534454345703,
        60.0
      ],
      [
        69.25993347167969,
        1571.6395263671875,
        59.99999237060547
      ],
      [
        1763.501953125,
        -816.68505859375,
        60.0
      ],
      [
        1764.96435546875,
        561.0765991210938,
        60.0
      ],
      [
        -2041.31298828125,
        1330.0,
        60.0
      ],
      [
        -1870.0,
        1330.0,
        60.000003814697266
      ],
      [
        -1880.0,
        1950.0,
        0.0
      ],
      [
        -1850.0,
        1950.0,
        0.0
      ],
      [
        -1850.0001220703125,
        1750.0,
        0.0
      ],
      [
        -1880.0,
        1950.0,
        60.0
      ],
      [
        -1870.0,
        1950.0,
        60.0
      ],
      [
        -1850.0001220703125,
        1750.0,
        0.0
      ],
      [
        -1880.0,
        1750.0,
        60.00000762939453
      ],
      [
        -1870.0,
        1750.0,
        60.00000762939453
      ],
      [
        -1548.7220458984375,
        694.0467529296875,
        60.000003814697266
      ],
      [
        -1449.9705810546875,
        93.32071685791016,
        60.0
      ],
      [
        -1850.0,
        2100.0,
        60.000003814697266
      ],
      [
        -1850.0,
        2000.0,
        60.0
      ],
      [
        -1850.0,
        1750.0,
        60.000003814697266
      ],
      [
        -1850.0,
        1330.0,
        60.0
      ],
      [
        -1850.0,
        1750.0,
        60.000003814697266
      ],
      [
        -1850.0,
        1950.0,
        0.0
      ],
      [
        -1850.0,
        1950.0,
        60.000003814697266
      ],
      [
        -1850.0,
        1330.0,
        60.000003814697266
      ],
      [
        -1749.4398193359375,
        2100.0,
        0.0
      ],
      [
        -1850.0,
        2100.0,
        60.0
      ],
      [
        -1779.8421630859375,
        2100.0,
        60.000003814697266
      ],
      [
        -1749.4398193359375,
        2100.0,
        0.0
      ],
      [
        -1744.3985595703125,
        2095.7197265625,
        -12.840713500976562
      ],
      [
        -1840.0,
        1800.0,
        60.00000762939453
      ],
      [
        -1840.0,
        1750.0,
        60.00000762939453
      ],
      [
        -1840.0,
        2000.0,
        60.0
      ],
      [
        -1840.0,
        1950.0,
        60.0
      ],
      [
        -1840.0,
        1950.0,
        60.00000762939453
      ],
      [
        -1840.0,
        1750.0,
        60.0
      ],
      [
        -1769.7081298828125,
        2100.0,
        60.000003814697266
      ],
      [
        -641.163330078125,
        1193.11767578125,
        0.0
      ],
      [
        -719.397705078125,
        1180.1796875,
        -237.38377380371094
      ],
      [
        -638.3679809570312,
        1286.7738037109375,
        60.0
      ],
      [
        -635.3445434570312,
        1256.204833984375,
        60.0
      ],
      [
        -635.927734375,
        1249.881591796875,
        53.98616027832031
      ],
      [
        -641.163330078125,
        1193.11767578125,
        0.0
      ],
      [
        -635.927734375,
        1249.881591796875,
        53.98616027832031
      ],
      [
        -619.3822631835938,
        1099.7568359375,
        0.0
      ],
      [
        -708.811279296875,
        1064.6099853515625,
        -285.22686767578125
      ],
      [
        -500.0,
        676.0741577148438,
        60.0
      ],
      [
        -619.3822631835938,
        1099.7568359375,
        0.0
      ],
      [
        -594.2252197265625,
        1079.9539794921875,
        60.0
      ],
      [
        -629.2988891601562,
        1195.0802001953125,
        60.0
      ],
      [
        -608.0948486328125,
        1104.192626953125,
        60.0
      ],
      [
        -624.7881469726562,
        1149.4739990234375,
        60.0
      ],
      [
        -1530.0,
        2100.0,
        60.00000762939453
      ],
      [
        -1850.0,
        2095.245361328125,
        200.0
      ],
      [
        -1850.0,
        2100.0,
        198.45751953125
      ],
      [
        -1850.0,
        1950.0,
        185.0
      ],
      [
        -1850.0,
        1950.0,
        150.0
      ],
      [
        -1851.7857666015625,
        1950.0,
        225.0
      ],
      [
        -1850.0,
        1950.0,
        199.99978637695312
      ],
      [
        -1850.0,
        1950.0,
        185.0
      ],
      [
        -1850.0,
        1950.0,
        60.00000762939453
      ],
      [
        -1850.0,
        1950.0,
        150.0
      ],
      [
        -1850.7816162109375,
        2100.0,
        200.0
      ],
      [
        -1867.6728515625,
        2102.3271484375,
        232.58013916015625
      ],
      [
        -1850.0,
        1750.0,
        150.0
      ],
      [
        -1850.0,
        1750.0,
        185.0
      ],
      [
        -1850.0,
        1750.0,
        185.0
      ],
      [
        -1851.7857666015625,
        1750.0,
        225.0
      ],
      [
        -1850.0,
        1750.0,
        199.99978637695312
      ],
      [
        -1850.0,
        1750.0,
        150.0
      ],
      [
        -1850.0,
        1750.0,
        60.0
      ],
      [
        -1850.0,
        1950.0,
        225.0
      ],
      [
        -1850.0,
        1750.0,
        225.0
      ],
      [
        -1779.8421630859375,
        2100.0,
        60.0
      ],
      [
        -1850.0,
        2100.0,
        198.45751953125
      ],
      [
        -1840.0,
        1750.0,
        185.0
      ],
      [
        -1840.0,
        1750.0,
        185.0
      ],
      [
        -1840.0,
        1750.0,
        225.0
      ],
      [
        -1840.0,
        1950.0,
        185.0
      ],
      [
        -1840.0,
        1950.0,
        225.0
      ],
      [
        -1840.0,
        1950.0,
        185.0
      ],
      [
        -1820.0,
        1958.985107421875,
        185.0
      ],
      [
        -1823.573486328125,
        2000.0,
        178.74642944335938
      ],
      [
        -1820.0,
        1950.0,
        187.91493225097656
      ],
      [
        -1820.0,
        1958.985107421875,
        185.0
      ],
      [
        -1838.791259765625,
        1950.0,
        225.0
      ],
      [
        -1820.0,
        1950.0,
        187.91493225097656
      ],
      [
        -1690.0,
        510.0,
        80.0
      ],
      [
        -1615.0,
        570.6521606445312,
        80.0
      ],
      [
        -1615.0,
        530.0,
        80.0
      ],
      [
        -1580.0,
        530.0,
        80.0
      ],
      [
        -1580.0,
        570.6521606445312,
        80.0
      ],
      [
        -1580.0,
        530.0,
        80.0
      ],
      [
        -1615.0,
        530.0,
        80.0
      ],
      [
        -1655.0,
        570.6521606445312,
        80.0
      ],
      [
        -1655.0,
        566.3043212890625,
        100.0
      ],
      [
        -1665.0,
        555.0,
        100.0
      ],
      [
        -1680.0,
        555.0,
        100.0
      ],
      [
        -1580.0,
        530.0,
        100.0
      ],
      [
        -1580.0,
        566.3043212890625,
        100.0
      ],
      [
        -1615.0,
        566.3043212890625,
        100.0
      ],
      [
        -1615.0,
        530.0,
        100.0
      ],
      [
        -1580.0,
        530.0,
        100.0
      ],
      [
        -1615.0,
        530.0,
        100.0
      ],
      [
        -1690.0,
        480.0,
        80.0
      ],
      [
        -1615.0,
        460.0,
        80.0
      ],
      [
        -1615.0,
        419.34783935546875,
        80.0
      ],
      [
        -1580.0,
        419.34783935546875,
        80.0
      ],
      [
        -1580.0,
        460.0,
        80.0
      ],
      [
        -1615.0,
        460.0,
        80.0
      ],
      [
        -1580.0,
        460.0,
        80.0
      ],
      [
        -1655.0,
        419.34783935546875,
        80.0
      ],
      [
        -1655.0,
        423.6956481933594,
        100.0
      ],
      [
        -1680.0,
        435.0,
        100.0
      ],
      [
        -1665.0,
        435.0,
        100.0
      ],
      [
        -1615.0,
        460.0,
        100.0
      ],
      [
        -1615.0,
        423.6956481933594,
        100.0
      ],
      [
        -1580.0,
        423.6956481933594,
        100.0
      ],
      [
        -1580.0,
        460.0,
        100.0
      ],
      [
        -1615.0,
        460.0,
        100.0
      ],
      [
        -1580.0,
        460.0,
        100.0
      ],
      [
        -1602.5,
        338.75,
        100.0
      ],
      [
        -1602.5,
        338.75,
        126.0
      ],
      [
        -1561.8763427734375,
        435.0,
        170.0
      ],
      [
        -1569.273681640625,
        480.0,
        170.0
      ],
      [
        -1574.205322265625,
        510.0,
        170.0
      ],
      [
        -1581.6026611328125,
        555.0,
        170.0
      ],
      [
        -1566.7401123046875,
        480.0,
        165.0
      ],
      [
        -1560.16455078125,
        440.0,
        165.0
      ],
      [
        -1578.2471923828125,
        550.0,
        165.0
      ],
      [
        -1571.6717529296875,
        510.0,
        165.0
      ],
      [
        -1569.273681640625,
        480.0,
        170.0
      ],
      [
        -1566.7401123046875,
        480.0,
        165.0
      ],
      [
        -1560.0,
        435.0,
        165.0
      ],
      [
        -1560.0,
        435.0,
        166.29705810546875
      ],
      [
        -1560.0,
        438.9979553222656,
        165.0
      ],
      [
        -1571.6717529296875,
        510.0,
        165.0
      ],
      [
        -1574.205322265625,
        510.0,
        170.0
      ],
      [
        -1560.0,
        435.0,
        145.0
      ],
      [
        -1680.0,
        435.0,
        145.0
      ],
      [
        -1680.0,
        435.0,
        140.0
      ],
      [
        -1665.0,
        435.0,
        140.0
      ],
      [
        -1665.0,
        435.0,
        145.0
      ],
      [
        -1655.0,
        427.0,
        145.0
      ],
      [
        -1655.0,
        435.0,
        145.0
      ],
      [
        -1580.0,
        427.0,
        145.0
      ],
      [
        -1580.0,
        435.0,
        145.0
      ],
      [
        -1680.0,
        435.0,
        145.0
      ],
      [
        -1680.0,
        440.0,
        145.0
      ],
      [
        -1560.0,
        440.0,
        164.67491149902344
      ],
      [
        -1560.1646728515625,
        440.0,
        165.0
      ],
      [
        -1560.0,
        440.0,
        164.67491149902344
      ],
      [
        -1655.0,
        480.0,
        116.0
      ],
      [
        -1690.0,
        480.0,
        116.0
      ],
      [
        -1580.0,
        460.0,
        116.0
      ],
      [
        -1580.0,
        460.0,
        116.0
      ],
      [
        -1580.0,
        425.0,
        116.0
      ],
      [
        -1680.0,
        435.0,
        116.0
      ],
      [
        -1680.0,
        455.0,
        116.0
      ],
      [
        -1680.0,
        435.0,
        116.0
      ],
      [
        -1665.0,
        435.0,
        116.0
      ],
      [
        -1602.5,
        340.0,
        116.0
      ],
      [
        -1605.0,
        340.0,
        116.0
      ],
      [
        -1602.5,
        338.75,
        116.0
      ],
      [
        -1602.5,
        340.0,
        116.0
      ],
      [
        -1655.0,
        480.0,
        106.0
      ],
      [
        -1655.0,
        480.0,
        116.0
      ],
      [
        -1561.53759765625,
        510.0,
        145.0
      ],
      [
        -1560.0,
        510.0,
        141.96554565429688
      ],
      [
        -1568.113037109375,
        550.0,
        145.0
      ],
      [
        -1561.53759765625,
        510.0,
        145.0
      ],
      [
        -1655.0,
        510.0,
        116.0
      ],
      [
        -1690.0,
        510.0,
        116.0
      ],
      [
        -1580.0,
        530.0,
        116.0
      ],
      [
        -1580.0,
        565.0,
        116.0
      ],
      [
        -1580.0,
        530.0,
        116.0
      ],
      [
        -1680.0,
        535.0,
        116.0
      ],
      [
        -1680.0,
        555.0,
        116.0
      ],
      [
        -1665.0,
        555.0,
        116.0
      ],
      [
        -1680.0,
        555.0,
        116.0
      ],
      [
        -1655.0,
        510.0,
        106.0
      ],
      [
        -1655.0,
        510.0,
        116.0
      ],
      [
        -1665.0,
        555.0,
        145.0
      ],
      [
        -1680.0,
        555.0,
        145.0
      ],
      [
        -1680.0,
        555.0,
        145.0
      ],
      [
        -1680.0,
        550.0,
        145.0
      ],
      [
        -1560.0,
        516.0587158203125,
        140.0
      ],
      [
        -1560.0,
        510.0,
        141.96554565429688
      ],
      [
        -1578.2471923828125,
        550.0,
        165.0
      ],
      [
        -1568.113037109375,
        550.0,
        145.0
      ],
      [
        -1764.8831787109375,
        2341.45556640625,
        429.5688781738281
      ],
      [
        -1688.00927734375,
        2338.93994140625,
        426.9678039550781
      ],
      [
        -1726.93994140625,
        2306.168212890625,
        426.9510498046875
      ],
      [
        -1698.7020263671875,
        2321.26171875,
        485.0
      ],
      [
        -1696.6204833984375,
        2325.9521484375,
        531.0
      ],
      [
        -1696.6878662109375,
        2317.318359375,
        429.10174560546875
      ],
      [
        -1680.0238037109375,
        2326.370849609375,
        460.0
      ],
      [
        -1696.6883544921875,
        2317.318359375,
        429.10040283203125
      ],
      [
        -1698.7020263671875,
        2321.26171875,
        485.0
      ],
      [
        -1679.344970703125,
        2327.900390625,
        475.0
      ],
      [
        -1680.0238037109375,
        2326.370849609375,
        460.0
      ],
      [
        -1679.344970703125,
        2327.900390625,
        475.0
      ],
      [
        -1689.564697265625,
        2329.5244140625,
        541.0
      ],
      [
        -1695.4891357421875,
        2328.501220703125,
        556.0
      ],
      [
        -1696.6204833984375,
        2325.9521484375,
        531.0
      ],
      [
        -1689.564697265625,
        2329.5244140625,
        541.0
      ],
      [
        -1724.361328125,
        2309.22998046875,
        475.0
      ],
      [
        -1723.2686767578125,
        2309.65234375,
        485.0
      ],
      [
        -1724.361328125,
        2309.22998046875,
        475.0
      ],
      [
        -1723.2686767578125,
        2309.65234375,
        485.0
      ],
      [
        -1718.2432861328125,
        2311.59521484375,
        531.0
      ],
      [
        -1680.0235595703125,
        2326.37158203125,
        475.0
      ],
      [
        -1680.0235595703125,
        2326.37158203125,
        475.0
      ],
      [
        -1693.22998046875,
        2321.265869140625,
        541.0
      ],
      [
        -1693.22998046875,
        2321.265869140625,
        541.0
      ],
      [
        -1695.2647705078125,
        2316.680908203125,
        541.0
      ],
      [
        -1695.2647705078125,
        2316.680908203125,
        541.0
      ],
      [
        -1710.2177734375,
        2309.33740234375,
        541.0
      ],
      [
        -1715.5120849609375,
        2312.651123046875,
        556.0
      ],
      [
        -1718.2432861328125,
        2311.59521484375,
        531.0
      ],
      [
        -1710.2177734375,
        2309.33740234375,
        541.0
      ],
      [
        -1752.8453369140625,
        2320.241943359375,
        475.0
      ],
      [
        -1753.2979736328125,
        2321.26171875,
        485.0
      ],
      [
        -1752.8453369140625,
        2320.241943359375,
        475.0
      ],
      [
        -1753.2978515625,
        2321.26171875,
        485.0
      ],
      [
        -1755.379638671875,
        2325.9521484375,
        531.0
      ],
      [
        -1761.6485595703125,
        2340.0,
        555.9052124023438
      ],
      [
        -1761.60546875,
        2339.98095703125,
        556.0
      ],
      [
        -1761.6077880859375,
        2339.98583984375,
        531.0
      ],
      [
        -1761.6396484375,
        2340.0,
        531.0468139648438
      ],
      [
        -1762.4354248046875,
        2329.52490234375,
        541.0
      ],
      [
        -1756.5108642578125,
        2328.50146484375,
        556.0
      ],
      [
        -1755.3795166015625,
        2325.9521484375,
        531.0
      ],
      [
        -1762.4354248046875,
        2329.52490234375,
        541.0
      ],
      [
        -1758.769775390625,
        2321.265380859375,
        541.0
      ],
      [
        -1758.769775390625,
        2321.265380859375,
        541.0
      ],
      [
        -1719.0673828125,
        2305.916015625,
        541.0
      ],
      [
        -1719.0673828125,
        2305.916015625,
        541.0
      ],
      [
        -1727.800537109375,
        2303.931884765625,
        541.0
      ],
      [
        -1727.80029296875,
        2303.931884765625,
        541.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.8705313205718994,
        0.4785127639770508,
        0.11489474773406982
      ],
      "plane_d": 4224.23291015625,
      "bbox_min": [
        -4205.1796875,
        -4636.2900390625,
        2.0755615234375
      ],
      "bbox_max": [
        -3093.3369140625,
        -2269.30224609375,
        1400.274658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8395622968673706,
        0.49151238799095154,
        0.231409952044487
      ],
      "plane_d": 4493.8125,
      "bbox_min": [
        -4205.1796875,
        -4636.2900390625,
        1040.098388671875
      ],
      "bbox_max": [
        -3093.3369140625,
        -2619.13720703125,
        1400.274658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.60302734375,
      "bbox_min": [
        -3833.671875,
        -4636.2900390625,
        1040.098388671875
      ],
      "bbox_max": [
        -3093.3369140625,
        -4327.0185546875,
        1390.1221923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9880585670471191,
        0.11992283910512924,
        0.09674030542373657
      ],
      "plane_d": 3834.249755859375,
      "bbox_min": [
        -3714.01416015625,
        -2363.246337890625,
        2.0755615234375
      ],
      "bbox_max": [
        -3605.362548828125,
        -2269.30224609375,
        1182.983154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429216384887695,
        0.10439633578062057,
        0.3162280023097992
      ],
      "plane_d": 3636.306884765625,
      "bbox_min": [
        -5545.388671875,
        -2269.10009765625,
        -300.0
      ],
      "bbox_max": [
        -3509.2900390625,
        5531.40869140625,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -4912.15185546875,
        -4693.75146484375,
        -300.0
      ],
      "bbox_max": [
        -157.67498779296875,
        5936.4208984375,
        1271.65087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        -4591.42333984375,
        3253.654296875,
        -300.0
      ],
      "bbox_max": [
        -2501.9697265625,
        5936.4208984375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3364546000957489,
        0.8870165944099426,
        0.31622767448425293
      ],
      "plane_d": 1797.4375,
      "bbox_min": [
        -3095.20947265625,
        -4693.75146484375,
        -300.0
      ],
      "bbox_max": [
        -1700.7498779296875,
        -2507.029541015625,
        1271.65087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.60302734375,
      "bbox_min": [
        -3095.20947265625,
        -4693.75146484375,
        1170.251708984375
      ],
      "bbox_max": [
        -2912.14697265625,
        -4604.0595703125,
        1271.65087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -3412.67578125,
        -3580.0,
        0.0
      ],
      "bbox_max": [
        -2808.593505859375,
        -3111.68505859375,
        1224.3428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6317505836486816,
        0.763104259967804,
        0.13624615967273712
      ],
      "plane_d": 4182.1328125,
      "bbox_min": [
        -3697.488525390625,
        -3196.55322265625,
        0.0
      ],
      "bbox_max": [
        -2861.24462890625,
        -20.0,
        1181.53662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7499687671661377,
        0.6611047983169556,
        -0.022072862833738327
      ],
      "plane_d": 4375.75,
      "bbox_min": [
        -3697.488525390625,
        -2969.13720703125,
        700.0
      ],
      "bbox_max": [
        -3195.179443359375,
        -2384.901123046875,
        1181.53662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        -3148.0,
        -200.42864990234375,
        95.0
      ],
      "bbox_max": [
        -2874.40625,
        -20.0,
        103.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9578263163566589,
        -0.2873478829860687
      ],
      "plane_d": 47.89131546020508,
      "bbox_min": [
        -3148.0,
        -21.5,
        95.0
      ],
      "bbox_max": [
        -3008.63330078125,
        -20.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -103.0,
      "bbox_min": [
        -3148.0,
        -24.0,
        100.0
      ],
      "bbox_max": [
        -3005.6767578125,
        -20.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8320503830909729,
        0.5547001957893372
      ],
      "plane_d": -38.829010009765625,
      "bbox_min": [
        -3148.0,
        -22.0,
        100.0
      ],
      "bbox_max": [
        -3007.491943359375,
        -20.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7320768237113953,
        0.5631359815597534,
        0.38332945108413696
      ],
      "plane_d": 259.0802001953125,
      "bbox_min": [
        -1942.9771728515625,
        -3113.202392578125,
        -300.0
      ],
      "bbox_max": [
        -1156.463623046875,
        -1953.526123046875,
        638.1046142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4769039750099182,
        0.7969357371330261,
        0.37075066566467285
      ],
      "plane_d": 1317.8309326171875,
      "bbox_min": [
        -1942.9771728515625,
        -3113.202392578125,
        0.0
      ],
      "bbox_max": [
        -1156.463623046875,
        -2021.68505859375,
        638.1046142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5844033360481262,
        0.7305042147636414,
        0.35332190990448
      ],
      "plane_d": 957.4642333984375,
      "bbox_min": [
        -1701.24462890625,
        -2876.868896484375,
        0.0
      ],
      "bbox_max": [
        -1156.463623046875,
        -2021.68505859375,
        499.8956604003906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -1201.24462890625,
        -2147.973876953125,
        0.0
      ],
      "bbox_max": [
        -1156.463623046875,
        -2021.68505859375,
        224.82118225097656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486832618713379,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 1755.0640869140625,
      "bbox_min": [
        -1846.306884765625,
        1230.0,
        -300.0
      ],
      "bbox_max": [
        -1430.0,
        2310.7763671875,
        -11.07925033569336
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486832618713379,
        0.3162277638912201
      ],
      "plane_d": 1992.23486328125,
      "bbox_min": [
        -1807.8961181640625,
        2000.0,
        -300.0
      ],
      "bbox_max": [
        -1430.0,
        2310.7763671875,
        -126.31155395507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 1451.4854736328125,
      "bbox_min": [
        -1445.5028076171875,
        2000.0,
        -300.0
      ],
      "bbox_max": [
        -1430.0,
        2310.7763671875,
        -253.49160766601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.927556574344635,
        0.1990949660539627,
        0.31622761487960815
      ],
      "plane_d": -711.715087890625,
      "bbox_min": [
        -3009.565185546875,
        -2028.7181396484375,
        -300.0
      ],
      "bbox_max": [
        -1067.126220703125,
        800.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -35.0,
      "bbox_min": [
        -2600.0,
        86.37356567382812,
        0.0
      ],
      "bbox_max": [
        -1418.4259033203125,
        800.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2320.0,
      "bbox_min": [
        -2560.0,
        86.37356567382812,
        0.0
      ],
      "bbox_max": [
        -1418.4259033203125,
        800.0,
        35.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2560.0,
      "bbox_min": [
        -2560.0,
        640.8333129882812,
        0.0
      ],
      "bbox_max": [
        -2560.0,
        680.0,
        35.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8825817704200745,
        0.14508481323719025,
        0.4472133219242096
      ],
      "plane_d": 1239.3453369140625,
      "bbox_min": [
        -1425.26611328125,
        86.37356567382812,
        0.0
      ],
      "bbox_max": [
        -1418.4259033203125,
        127.98397827148438,
        3.9378738403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2560.0,
      "bbox_min": [
        -2600.0,
        580.0,
        35.0
      ],
      "bbox_max": [
        -2340.0,
        702.5,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 580.0,
      "bbox_min": [
        -2600.0,
        580.0,
        70.0
      ],
      "bbox_max": [
        -2560.0,
        580.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2340.0,
      "bbox_min": [
        -2340.0,
        666.3665161132812,
        35.0
      ],
      "bbox_max": [
        -2340.0,
        702.5,
        55.3238525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2340.0,
      "bbox_min": [
        -2345.85791015625,
        663.2296752929688,
        45.000003814697266
      ],
      "bbox_max": [
        -2340.0,
        730.6066284179688,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8753690123558044,
        0.48345550894737244,
        0.0
      ],
      "plane_d": 1700.275634765625,
      "bbox_min": [
        -2345.85791015625,
        720.0,
        47.5
      ],
      "bbox_max": [
        -2340.0,
        730.6066284179688,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -409.9999694824219,
      "bbox_min": [
        -1820.0,
        410.0,
        60.0
      ],
      "bbox_max": [
        -1694.8935546875,
        476.6761474609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        -1720.0,
        410.0,
        60.0
      ],
      "bbox_max": [
        -1694.8935546875,
        476.6761474609375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        -1984.1668701171875,
        -320.0,
        100.0
      ],
      "bbox_max": [
        -1785.0,
        -253.8881378173828,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1800.0,
      "bbox_min": [
        -1984.1668701171875,
        -270.0,
        100.0
      ],
      "bbox_max": [
        -1800.0,
        -253.8881378173828,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9138115644454956,
        0.0,
        -0.40613847970962524
      ],
      "plane_d": 1853.6160888671875,
      "bbox_min": [
        -1984.1668701171875,
        -270.0,
        100.0
      ],
      "bbox_max": [
        -1983.111083984375,
        -267.5752258300781,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19015046954154968,
        0.9817549586296082,
        -6.744421199300632e-08
      ],
      "plane_d": -114.39622497558594,
      "bbox_min": [
        -1984.1668701171875,
        -267.7796936035156,
        100.0
      ],
      "bbox_max": [
        -1983.111083984375,
        -267.5752258300781,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 1463.7110595703125,
      "bbox_min": [
        -1800.57275390625,
        -285.0,
        100.0
      ],
      "bbox_max": [
        -1785.0,
        -252.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1800.0,
      "bbox_min": [
        -1800.57275390625,
        -253.8881378173828,
        100.0
      ],
      "bbox_max": [
        -1800.0,
        -252.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 252.0,
      "bbox_min": [
        -1800.57275390625,
        -252.0,
        100.0
      ],
      "bbox_max": [
        -1800.0,
        -252.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8819230198860168,
        0.4713937044143677,
        -0.0
      ],
      "plane_d": 1786.76611328125,
      "bbox_min": [
        -1984.250244140625,
        -270.0,
        102.0
      ],
      "bbox_max": [
        -1926.4815673828125,
        -159.99630737304688,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4713982939720154,
        0.8819205164909363,
        0.0
      ],
      "plane_d": -755.229736328125,
      "bbox_min": [
        -1931.783935546875,
        -176.21759033203125,
        102.0
      ],
      "bbox_max": [
        -1926.4815673828125,
        -173.3833770751953,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20364226400852203,
        0.9790453314781189,
        0.0
      ],
      "plane_d": -144.11712646484375,
      "bbox_min": [
        -1926.4815673828125,
        -248.68228149414062,
        102.0
      ],
      "bbox_max": [
        -1885.65771484375,
        -171.8807373046875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9569399356842041,
        0.2902863025665283,
        -0.0
      ],
      "plane_d": 1884.5067138671875,
      "bbox_min": [
        -1926.4815673828125,
        -230.65042114257812,
        102.0
      ],
      "bbox_max": [
        -1899.337646484375,
        -171.8807373046875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4713982939720154,
        0.8819205164909363,
        0.0
      ],
      "plane_d": -755.229736328125,
      "bbox_min": [
        -1926.4815673828125,
        -173.3833770751953,
        102.0
      ],
      "bbox_max": [
        -1923.6702880859375,
        -171.8807373046875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 269.0,
      "bbox_min": [
        -1870.0,
        -269.0,
        102.0
      ],
      "bbox_max": [
        -1858.5089111328125,
        -269.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 1463.7110595703125,
      "bbox_min": [
        -1859.5,
        -285.0,
        102.0
      ],
      "bbox_max": [
        -1785.0,
        -252.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1800.0,
      "bbox_min": [
        -1800.0,
        -270.0,
        102.0
      ],
      "bbox_max": [
        -1800.0,
        -252.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2036415934562683,
        0.9790455102920532,
        0.0
      ],
      "plane_d": -144.11582946777344,
      "bbox_min": [
        -1860.0,
        -252.0,
        102.0
      ],
      "bbox_max": [
        -1823.48876953125,
        -168.6193389892578,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1859.5,
      "bbox_min": [
        -1859.5,
        -252.0,
        102.0
      ],
      "bbox_max": [
        -1859.5,
        -242.60000610351562,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2888985574245453,
        0.957359790802002,
        0.0
      ],
      "plane_d": -322.0630187988281,
      "bbox_min": [
        -1845.7618408203125,
        -217.06915283203125,
        102.0
      ],
      "bbox_max": [
        -1832.2109375,
        -172.5132598876953,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8577982783317566,
        0.3553174138069153,
        -0.371391624212265
      ],
      "plane_d": 1672.5972900390625,
      "bbox_min": [
        -1837.1875,
        -200.6365509033203,
        102.0
      ],
      "bbox_max": [
        -1824.0693359375,
        -168.6193389892578,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29028621315956116,
        0.9569398760795593,
        2.0261003896848706e-07
      ],
      "plane_d": -338.03289794921875,
      "bbox_min": [
        -1837.1875,
        -200.6365509033203,
        102.0
      ],
      "bbox_max": [
        -1824.0693359375,
        -168.6193389892578,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826831579208374,
        0.9238796234130859,
        9.481108804720861e-07
      ],
      "plane_d": -546.6051025390625,
      "bbox_min": [
        -1837.1875,
        -169.346435546875,
        102.0
      ],
      "bbox_max": [
        -1835.4322509765625,
        -168.6193389892578,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.881920337677002,
        0.47139838337898254,
        0.0
      ],
      "plane_d": 1709.1373291015625,
      "bbox_min": [
        -1872.76171875,
        -172.86740112304688,
        102.0
      ],
      "bbox_max": [
        -1845.572509765625,
        -122.0,
        103.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.471407413482666,
        0.8819156885147095,
        0.0
      ],
      "plane_d": -736.6016235351562,
      "bbox_min": [
        -1856.3115234375,
        -157.0188446044922,
        102.0
      ],
      "bbox_max": [
        -1854.5477294921875,
        -156.0760498046875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8188533186912537,
        0.43766626715660095,
        -0.3713861107826233
      ],
      "plane_d": 1613.56884765625,
      "bbox_min": [
        -1851.5001220703125,
        -140.371337890625,
        102.0
      ],
      "bbox_max": [
        -1848.881591796875,
        -138.41893005371094,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4714047312736511,
        0.8819169998168945,
        3.574388983906829e-06
      ],
      "plane_d": -749.9423828125,
      "bbox_min": [
        -1851.5001220703125,
        -139.31459045410156,
        102.0
      ],
      "bbox_max": [
        -1849.824462890625,
        -138.41893005371094,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 38.0,
      "bbox_min": [
        -2581.0,
        -122.0,
        100.0
      ],
      "bbox_max": [
        -1850.193115234375,
        -20.000003814697266,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 92.0,
      "bbox_min": [
        -2581.0,
        -122.0,
        100.0
      ],
      "bbox_max": [
        -1850.193115234375,
        -92.0,
        102.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.881921112537384,
        0.4713970720767975,
        -0.0
      ],
      "plane_d": 1689.2347412109375,
      "bbox_min": [
        -1858.985595703125,
        -122.0,
        100.0
      ],
      "bbox_max": [
        -1850.193115234375,
        -105.5504150390625,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2570.0,
      "bbox_min": [
        -2570.0,
        -38.0,
        100.0
      ],
      "bbox_max": [
        -1992.5,
        -20.000003814697266,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21847234666347504,
        0.9758431911468506,
        0.0
      ],
      "plane_d": 543.1404418945312,
      "bbox_min": [
        -2396.75,
        -23.75,
        100.0
      ],
      "bbox_max": [
        -1992.5,
        -20.000003814697266,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1425.7041015625,
      "bbox_min": [
        -1996.25,
        -23.75,
        100.0
      ],
      "bbox_max": [
        -1992.5,
        -20.000003814697266,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7730104923248291,
        0.6343932747840881,
        -0.0
      ],
      "plane_d": 1580.6051025390625,
      "bbox_min": [
        -1956.9598388671875,
        -122.0,
        102.0
      ],
      "bbox_max": [
        -1872.76171875,
        -101.20161437988281,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8819204568862915,
        0.4713984429836273,
        -0.0
      ],
      "plane_d": 1709.137451171875,
      "bbox_min": [
        -1889.848876953125,
        -122.0,
        102.0
      ],
      "bbox_max": [
        -1872.76171875,
        -101.20161437988281,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343925595283508,
        0.7730111479759216,
        0.0
      ],
      "plane_d": -1119.6953125,
      "bbox_min": [
        -1889.848876953125,
        -102.47039794921875,
        102.0
      ],
      "bbox_max": [
        -1888.3028564453125,
        -101.20161437988281,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.772010087966919,
        0.5158162713050842,
        -0.3713946044445038
      ],
      "plane_d": 1536.302978515625,
      "bbox_min": [
        -1868.6873779296875,
        -111.65980529785156,
        102.0
      ],
      "bbox_max": [
        -1865.9964599609375,
        -109.77464294433594,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.717719316482544,
        0.5890228748321533,
        -0.37139081954956055
      ],
      "plane_d": 1441.538818359375,
      "bbox_min": [
        -1888.5838623046875,
        -84.76210021972656,
        102.0
      ],
      "bbox_max": [
        -1885.8463134765625,
        -82.96232604980469,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2570.0,
      "bbox_min": [
        -2570.0,
        -38.0,
        102.0
      ],
      "bbox_max": [
        -1992.5,
        -21.333337783813477,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21847234666347504,
        0.9758431911468506,
        0.0
      ],
      "plane_d": 543.1404418945312,
      "bbox_min": [
        -2390.79443359375,
        -23.75,
        102.0
      ],
      "bbox_max": [
        -1992.5,
        -21.333337783813477,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1425.7041015625,
      "bbox_min": [
        -1994.9166259765625,
        -23.75,
        102.0
      ],
      "bbox_max": [
        -1992.5,
        -21.333337783813477,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6351796984672546,
        0.4459250569343567,
        0.6306326985359192
      ],
      "plane_d": 1583.486328125,
      "bbox_min": [
        -2680.8134765625,
        -220.81336975097656,
        312.95953369140625
      ],
      "bbox_max": [
        -2645.6923828125,
        -185.69219970703125,
        330.49847412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7926474809646606,
        0.0,
        0.6096802353858948
      ],
      "plane_d": 1923.4415283203125,
      "bbox_min": [
        -2680.8134765625,
        -220.81336975097656,
        312.95953369140625
      ],
      "bbox_max": [
        -2645.6923828125,
        -185.69219970703125,
        330.49847412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20758119225502014,
        0.6917053461074829,
        0.6917034983634949
      ],
      "plane_d": 480.6173400878906,
      "bbox_min": [
        -2680.8134765625,
        -220.81336975097656,
        302.04046630859375
      ],
      "bbox_max": [
        -2615.16552734375,
        -162.66989135742188,
        330.49847412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7926474809646606,
        0.0,
        0.6096802353858948
      ],
      "plane_d": 1923.4415283203125,
      "bbox_min": [
        -2680.8134765625,
        -195.69224548339844,
        314.0048828125
      ],
      "bbox_max": [
        -2659.175537109375,
        -162.66989135742188,
        330.49847412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6351800560951233,
        -0.44592615962028503,
        0.6306314468383789
      ],
      "plane_d": 1418.4951171875,
      "bbox_min": [
        -2678.0810546875,
        -174.30775451660156,
        314.0048828125
      ],
      "bbox_max": [
        -2659.175537109375,
        -162.66989135742188,
        326.94610595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6933766603469849,
        0.6933737397193909,
        0.19611626863479614
      ],
      "plane_d": -1435.5511474609375,
      "bbox_min": [
        -2236.326904296875,
        -245.15045166015625,
        270.0
      ],
      "bbox_max": [
        -2230.0,
        -235.99124145507812,
        295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284767508506775,
        0.0,
        -0.3713906705379486
      ],
      "plane_d": 2388.042236328125,
      "bbox_min": [
        -2520.0,
        -93.0,
        130.0
      ],
      "bbox_max": [
        -2518.0,
        -92.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284767508506775,
        0.0,
        -0.3713906705379486
      ],
      "plane_d": 2388.042236328125,
      "bbox_min": [
        -2583.138916015625,
        -92.0,
        105.0
      ],
      "bbox_max": [
        -2519.60009765625,
        -38.34710693359375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        -2583.138916015625,
        -85.53663635253906,
        117.49983978271484
      ],
      "bbox_max": [
        -2521.7998046875,
        -39.99999237060547,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2520.0,
      "bbox_min": [
        -2525.0,
        -92.0,
        105.0
      ],
      "bbox_max": [
        -2520.0,
        -38.34710693359375,
        130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.9532307386398315,
        -0.3022438883781433
      ],
      "plane_d": 117.04975891113281,
      "bbox_min": [
        -2525.0,
        -89.5,
        105.0
      ],
      "bbox_max": [
        -2520.0,
        -83.0,
        125.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2579.5,
      "bbox_min": [
        -2582.47216796875,
        -92.0,
        131.0
      ],
      "bbox_max": [
        -2518.0,
        -40.666664123535156,
        158.53330993652344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071053385734558,
        0.7071082592010498,
        -0.0
      ],
      "plane_d": 1854.835693359375,
      "bbox_min": [
        -2582.47216796875,
        -43.63890838623047,
        131.0
      ],
      "bbox_max": [
        -2579.5,
        -40.666664123535156,
        135.45835876464844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284767508506775,
        0.0,
        -0.3713906705379486
      ],
      "plane_d": 2388.042236328125,
      "bbox_min": [
        -2579.5,
        -92.0,
        131.0
      ],
      "bbox_max": [
        -2518.0,
        -40.66666793823242,
        158.53330993652344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071053385734558,
        0.7071082592010498,
        -0.0
      ],
      "plane_d": 1854.835693359375,
      "bbox_min": [
        -2579.5,
        -60.59257507324219,
        131.0
      ],
      "bbox_max": [
        -2579.1865234375,
        -43.63890838623047,
        158.53330993652344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2579.1865234375,
      "bbox_min": [
        -2579.1865234375,
        -60.59257507324219,
        158.14486694335938
      ],
      "bbox_max": [
        -2579.1865234375,
        -58.76324462890625,
        158.53330993652344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2570.0,
      "bbox_min": [
        -2570.0,
        -38.0,
        103.0
      ],
      "bbox_max": [
        -2570.0,
        -22.000003814697266,
        127.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071056962013245,
        -0.7071078419685364,
        0.0
      ],
      "plane_d": 1762.9124755859375,
      "bbox_min": [
        -2608.952392578125,
        -115.81336975097656,
        103.0
      ],
      "bbox_max": [
        -2380.0,
        -22.000003814697266,
        243.72006225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2579.1865234375,
      "bbox_min": [
        -2579.1865234375,
        -86.04759216308594,
        158.53329467773438
      ],
      "bbox_max": [
        -2579.1865234375,
        -59.0222053527832,
        199.07138061523438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.21847234666347504,
        0.9758431911468506,
        0.0
      ],
      "plane_d": 543.1404418945312,
      "bbox_min": [
        -2387.816650390625,
        -23.75,
        103.0
      ],
      "bbox_max": [
        -2380.0,
        -22.000003814697266,
        105.62499237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 316.0,
      "bbox_min": [
        -1880.0,
        -2030.1519775390625,
        103.0
      ],
      "bbox_max": [
        -1111.164794921875,
        -270.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1785.0,
      "bbox_min": [
        -1800.0,
        -316.0,
        103.0
      ],
      "bbox_max": [
        -1785.0,
        -270.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 1463.7110595703125,
      "bbox_min": [
        -1800.0,
        -285.0,
        103.0
      ],
      "bbox_max": [
        -1785.0,
        -270.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 380.0,
      "bbox_min": [
        -2160.0,
        -396.82958984375,
        135.0
      ],
      "bbox_max": [
        -1905.0,
        -270.0,
        339.9533996582031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8666224479675293,
        -0.0,
        0.49896445870399475
      ],
      "plane_d": 1583.5555419921875,
      "bbox_min": [
        -2070.0,
        -317.0,
        135.0
      ],
      "bbox_max": [
        -1905.0,
        -283.0,
        294.19537353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9138123989105225,
        0.0,
        -0.4061366617679596
      ],
      "plane_d": 1853.6173095703125,
      "bbox_min": [
        -2003.499267578125,
        -283.0,
        135.0
      ],
      "bbox_max": [
        -1946.00537109375,
        -270.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8849160075187683,
        0.3665442168712616,
        0.2873479723930359
      ],
      "plane_d": 1814.4259033203125,
      "bbox_min": [
        -2003.499267578125,
        -270.7937927246094,
        186.69786071777344
      ],
      "bbox_max": [
        -1999.1798095703125,
        -270.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1960.0,
      "bbox_min": [
        -1960.0,
        -283.0,
        135.0
      ],
      "bbox_max": [
        -1960.0,
        -270.0,
        154.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 269.0,
      "bbox_min": [
        -1870.0,
        -270.0,
        103.0
      ],
      "bbox_max": [
        -1800.0,
        -252.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1800.0,
      "bbox_min": [
        -1800.0,
        -270.0,
        103.0
      ],
      "bbox_max": [
        -1800.0,
        -269.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1800.0,
      "bbox_min": [
        -1859.5,
        -269.0,
        103.0
      ],
      "bbox_max": [
        -1800.0,
        -252.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1859.5,
      "bbox_min": [
        -1859.5,
        -252.0,
        103.0
      ],
      "bbox_max": [
        -1850.0,
        -242.10000610351562,
        115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 244.89999389648438,
      "bbox_min": [
        -1857.800048828125,
        -244.89999389648438,
        103.19999694824219
      ],
      "bbox_max": [
        -1857.4000244140625,
        -244.89999389648438,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 242.10000610351562,
      "bbox_min": [
        -1854.1629638671875,
        -242.60000610351562,
        103.0
      ],
      "bbox_max": [
        -1850.0,
        -242.10000610351562,
        115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 242.60000610351562,
      "bbox_min": [
        -1854.1629638671875,
        -242.60000610351562,
        103.0
      ],
      "bbox_max": [
        -1850.0,
        -242.60000610351562,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9569401144981384,
        0.29028573632240295,
        -0.0
      ],
      "plane_d": 1789.2259521484375,
      "bbox_min": [
        -2017.527587890625,
        -268.9176025390625,
        103.0
      ],
      "bbox_max": [
        -1799.859619140625,
        -22.000003814697266,
        169.0384063720703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8819218873977661,
        0.47139546275138855,
        -0.0
      ],
      "plane_d": 1682.269775390625,
      "bbox_min": [
        -2017.527587890625,
        -268.9176025390625,
        103.0
      ],
      "bbox_max": [
        -1806.72509765625,
        -22.000003814697266,
        169.0384063720703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238811731338501,
        0.38267943263053894,
        3.4577765291032847e-06
      ],
      "plane_d": 1939.3184814453125,
      "bbox_min": [
        -2017.527587890625,
        -268.9176025390625,
        103.0
      ],
      "bbox_max": [
        -1806.72509765625,
        -22.000003814697266,
        169.0384063720703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8849160075187683,
        0.3665442168712616,
        0.2873479723930359
      ],
      "plane_d": 1814.4259033203125,
      "bbox_min": [
        -2017.527587890625,
        -268.9176025390625,
        150.0
      ],
      "bbox_max": [
        -1988.17041015625,
        -208.33090209960938,
        169.0384063720703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20364226400852203,
        0.9790453314781189,
        0.0
      ],
      "plane_d": -144.11712646484375,
      "bbox_min": [
        -1903.67529296875,
        -248.68228149414062,
        109.26533508300781
      ],
      "bbox_max": [
        -1894.0877685546875,
        -246.7701873779297,
        127.30290985107422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20364226400852203,
        0.9790453314781189,
        0.0
      ],
      "plane_d": -144.11712646484375,
      "bbox_min": [
        -1903.5289306640625,
        -246.77023315429688,
        110.20138549804688
      ],
      "bbox_max": [
        -1828.8541259765625,
        -42.66666793823242,
        139.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6343935132026672,
        0.7730103731155396,
        -0.0
      ],
      "plane_d": 1240.5682373046875,
      "bbox_min": [
        -1903.5289306640625,
        -168.0594024658203,
        118.71874237060547
      ],
      "bbox_max": [
        -1828.8541259765625,
        -42.66666793823242,
        139.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.772010087966919,
        0.5158162713050842,
        -0.3713946044445038
      ],
      "plane_d": 1536.302978515625,
      "bbox_min": [
        -1861.876220703125,
        -168.0594024658203,
        118.71874237060547
      ],
      "bbox_max": [
        -1828.8541259765625,
        -106.27922058105469,
        118.72901153564453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8577982783317566,
        0.3553174138069153,
        -0.371391624212265
      ],
      "plane_d": 1672.5972900390625,
      "bbox_min": [
        -1829.619384765625,
        -168.0594024658203,
        118.71874237060547
      ],
      "bbox_max": [
        -1828.8541259765625,
        -166.21163940429688,
        118.72901153564453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2036415934562683,
        0.9790455102920532,
        0.0
      ],
      "plane_d": -144.11582946777344,
      "bbox_min": [
        -1903.7515869140625,
        -248.68228149414062,
        109.22000885009766
      ],
      "bbox_max": [
        -1828.873046875,
        -233.20550537109375,
        116.83668518066406
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 242.10000610351562,
      "bbox_min": [
        -1860.851806640625,
        -242.10000610351562,
        113.49276733398438
      ],
      "bbox_max": [
        -1851.58154296875,
        -242.10000610351562,
        114.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9556644558906555,
        0.29445791244506836,
        0.0
      ],
      "plane_d": 1892.1240234375,
      "bbox_min": [
        -1903.7515869140625,
        -248.68228149414062,
        109.22000885009766
      ],
      "bbox_max": [
        -1903.280517578125,
        -247.1532745361328,
        109.26610565185547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9573588371276855,
        0.2889013886451721,
        1.3068780390312895e-05
      ],
      "plane_d": 1816.62646484375,
      "bbox_min": [
        -1905.108154296875,
        -248.68228149414062,
        108.29483795166016
      ],
      "bbox_max": [
        -1817.4049072265625,
        -167.13636779785156,
        118.89404296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2036415934562683,
        0.9790455102920532,
        0.0
      ],
      "plane_d": -144.11582946777344,
      "bbox_min": [
        -1905.108154296875,
        -248.68228149414062,
        108.29483795166016
      ],
      "bbox_max": [
        -1828.873046875,
        -233.20550537109375,
        116.82693481445312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 242.10000610351562,
      "bbox_min": [
        -1860.8492431640625,
        -242.10000610351562,
        112.37670135498047
      ],
      "bbox_max": [
        -1851.58154296875,
        -242.10000610351562,
        114.38392639160156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9556644558906555,
        0.29445791244506836,
        0.0
      ],
      "plane_d": 1892.1240234375,
      "bbox_min": [
        -1905.108154296875,
        -248.68228149414062,
        108.29483795166016
      ],
      "bbox_max": [
        -1903.280517578125,
        -242.7508087158203,
        109.22071075439453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29028621315956116,
        0.9569398760795593,
        2.0261003896848706e-07
      ],
      "plane_d": -338.03289794921875,
      "bbox_min": [
        -1829.2408447265625,
        -200.23683166503906,
        117.92227172851562
      ],
      "bbox_max": [
        -1817.4049072265625,
        -167.13636779785156,
        118.89404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8884972333908081,
        0.26951852440834045,
        -0.37139254808425903
      ],
      "plane_d": 1712.8607177734375,
      "bbox_min": [
        -1818.244873046875,
        -200.23683166503906,
        118.1753921508789
      ],
      "bbox_max": [
        -1817.4049072265625,
        -198.239501953125,
        118.89404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8577982783317566,
        0.3553174138069153,
        -0.371391624212265
      ],
      "plane_d": 1672.5972900390625,
      "bbox_min": [
        -1829.2408447265625,
        -168.0625457763672,
        118.70845794677734
      ],
      "bbox_max": [
        -1828.8541259765625,
        -167.13636779785156,
        118.72900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.772010087966919,
        0.5158162713050842,
        -0.3713946044445038
      ],
      "plane_d": 1536.302978515625,
      "bbox_min": [
        -1861.883056640625,
        -107.11361694335938,
        118.70845794677734
      ],
      "bbox_max": [
        -1861.3236083984375,
        -106.27922058105469,
        118.72900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343734264373779,
        0.7730268239974976,
        -1.0536708941799589e-05
      ],
      "plane_d": -1133.00244140625,
      "bbox_min": [
        -1884.7254638671875,
        -81.00112915039062,
        117.88179779052734
      ],
      "bbox_max": [
        -1880.931884765625,
        -78.92916870117188,
        118.89376831054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.717719316482544,
        0.5890228748321533,
        -0.37139081954956055
      ],
      "plane_d": 1441.538818359375,
      "bbox_min": [
        -1882.4228515625,
        -80.64713287353516,
        118.17537689208984
      ],
      "bbox_max": [
        -1880.931884765625,
        -78.92916870117188,
        118.89376831054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9556644558906555,
        0.29445791244506836,
        0.0
      ],
      "plane_d": 1892.1240234375,
      "bbox_min": [
        -1940.4696044921875,
        -248.68228149414062,
        103.0
      ],
      "bbox_max": [
        -1885.65771484375,
        -159.99630737304688,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20364226400852203,
        0.9790453314781189,
        0.0
      ],
      "plane_d": -144.11712646484375,
      "bbox_min": [
        -1926.4815673828125,
        -248.68228149414062,
        103.0
      ],
      "bbox_max": [
        -1885.65771484375,
        -171.8807373046875,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9569399356842041,
        0.2902863025665283,
        -0.0
      ],
      "plane_d": 1884.5067138671875,
      "bbox_min": [
        -1926.4815673828125,
        -230.65042114257812,
        103.0
      ],
      "bbox_max": [
        -1899.337646484375,
        -171.8807373046875,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4713982939720154,
        0.8819205164909363,
        0.0
      ],
      "plane_d": -755.229736328125,
      "bbox_min": [
        -1926.4815673828125,
        -173.3833770751953,
        103.0
      ],
      "bbox_max": [
        -1923.6702880859375,
        -171.8807373046875,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8819218873977661,
        0.47139570116996765,
        -1.3139393558958545e-05
      ],
      "plane_d": 1786.765625,
      "bbox_min": [
        -1940.4696044921875,
        -248.68228149414062,
        106.0
      ],
      "bbox_max": [
        -1885.65771484375,
        -159.99630737304688,
        110.0301513671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9556644558906555,
        0.29445791244506836,
        0.0
      ],
      "plane_d": 1892.1240234375,
      "bbox_min": [
        -1909.169677734375,
        -248.68228149414062,
        106.0
      ],
      "bbox_max": [
        -1894.088134765625,
        -229.56898498535156,
        109.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9569399356842041,
        0.2902863025665283,
        -0.0
      ],
      "plane_d": 1884.5067138671875,
      "bbox_min": [
        -1931.783935546875,
        -246.770263671875,
        106.0
      ],
      "bbox_max": [
        -1885.65771484375,
        -171.8807373046875,
        110.0301513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20364226400852203,
        0.9790453314781189,
        0.0
      ],
      "plane_d": -144.11712646484375,
      "bbox_min": [
        -1894.088134765625,
        -246.770263671875,
        106.0
      ],
      "bbox_max": [
        -1885.65771484375,
        -245.0167236328125,
        110.0301513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1425.7041015625,
      "bbox_min": [
        -1994.25,
        -23.75,
        103.0
      ],
      "bbox_max": [
        -1992.5,
        -22.000003814697266,
        105.62499237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 242.10000610351562,
      "bbox_min": [
        -1860.7376708984375,
        -243.63369750976562,
        103.0
      ],
      "bbox_max": [
        -1851.58154296875,
        -242.10000610351562,
        113.18810272216797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1859.5,
      "bbox_min": [
        -1860.0,
        -243.63369750976562,
        103.0
      ],
      "bbox_max": [
        -1854.1629638671875,
        -242.60000610351562,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 242.60000610351562,
      "bbox_min": [
        -1860.0,
        -242.60000610351562,
        103.0
      ],
      "bbox_max": [
        -1859.5,
        -242.60000610351562,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 242.60000610351562,
      "bbox_min": [
        -1859.5,
        -242.60000610351562,
        103.0
      ],
      "bbox_max": [
        -1854.1629638671875,
        -242.60000610351562,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -106.0,
      "bbox_min": [
        -1873.11328125,
        -217.06915283203125,
        103.0
      ],
      "bbox_max": [
        -1832.2109375,
        -175.59759521484375,
        113.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -103.4000015258789,
      "bbox_min": [
        -1874.207275390625,
        -184.8414306640625,
        103.4000015258789
      ],
      "bbox_max": [
        -1850.6251220703125,
        -173.02023315429688,
        103.4000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343925595283508,
        0.7730111479759216,
        0.0
      ],
      "plane_d": -1119.6953125,
      "bbox_min": [
        -1889.848876953125,
        -157.0188446044922,
        103.0
      ],
      "bbox_max": [
        -1854.5477294921875,
        -101.20161437988281,
        113.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.471407413482666,
        0.8819156885147095,
        0.0
      ],
      "plane_d": -736.6016235351562,
      "bbox_min": [
        -1856.3115234375,
        -157.0188446044922,
        103.0
      ],
      "bbox_max": [
        -1854.5477294921875,
        -156.0760498046875,
        113.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826831579208374,
        0.9238796234130859,
        9.481108804720861e-07
      ],
      "plane_d": -546.6051025390625,
      "bbox_min": [
        -1836.8970947265625,
        -201.9700164794922,
        103.0
      ],
      "bbox_max": [
        -1817.679931640625,
        -166.21163940429688,
        118.72901153564453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555586814880371,
        0.8314773440361023,
        -3.0793328278377885e-06
      ],
      "plane_d": -946.0123291015625,
      "bbox_min": [
        -1888.3409423828125,
        -110.65560913085938,
        103.0
      ],
      "bbox_max": [
        -1861.883056640625,
        -79.11146545410156,
        118.70849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.717719316482544,
        0.5890228748321533,
        -0.37139081954956055
      ],
      "plane_d": 1441.538818359375,
      "bbox_min": [
        -1888.3409423828125,
        -84.44525146484375,
        103.0
      ],
      "bbox_max": [
        -1881.141357421875,
        -79.11146545410156,
        118.2161865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343734264373779,
        0.7730268239974976,
        -1.0536708941799589e-05
      ],
      "plane_d": -1133.00244140625,
      "bbox_min": [
        -1888.3409423828125,
        -83.9682846069336,
        103.0
      ],
      "bbox_max": [
        -1882.4228515625,
        -79.11146545410156,
        118.17537689208984
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8188533186912537,
        0.43766626715660095,
        -0.3713861107826233
      ],
      "plane_d": 1613.56884765625,
      "bbox_min": [
        -1849.8385009765625,
        -140.1827850341797,
        103.0
      ],
      "bbox_max": [
        -1848.794677734375,
        -138.3724365234375,
        103.24657440185547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4714047312736511,
        0.8819169998168945,
        3.574388983906829e-06
      ],
      "plane_d": -749.9423828125,
      "bbox_min": [
        -1849.8385009765625,
        -138.42642211914062,
        103.0
      ],
      "bbox_max": [
        -1849.7374267578125,
        -138.3724365234375,
        103.24657440185547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8884972333908081,
        0.26951852440834045,
        -0.37139254808425903
      ],
      "plane_d": 1712.8607177734375,
      "bbox_min": [
        -1824.084716796875,
        -201.99888610839844,
        103.0
      ],
      "bbox_max": [
        -1823.3935546875,
        -200.05613708496094,
        103.24867248535156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29028621315956116,
        0.9569398760795593,
        2.0261003896848706e-07
      ],
      "plane_d": -338.03289794921875,
      "bbox_min": [
        -1824.084716796875,
        -200.08966064453125,
        103.0
      ],
      "bbox_max": [
        -1823.97412109375,
        -200.05613708496094,
        103.24864196777344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.717719316482544,
        0.5890228748321533,
        -0.37139081954956055
      ],
      "plane_d": 1441.538818359375,
      "bbox_min": [
        -1887.1275634765625,
        -84.50834655761719,
        103.0
      ],
      "bbox_max": [
        -1885.7694091796875,
        -82.89871215820312,
        103.25068664550781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343734264373779,
        0.7730268239974976,
        -1.0536708941799589e-05
      ],
      "plane_d": -1133.00244140625,
      "bbox_min": [
        -1887.1275634765625,
        -82.97257232666016,
        103.0
      ],
      "bbox_max": [
        -1887.03759765625,
        -82.89871215820312,
        103.25068664550781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8849160075187683,
        0.3665442168712616,
        0.2873479723930359
      ],
      "plane_d": 1814.4259033203125,
      "bbox_min": [
        -2017.527587890625,
        -240.25466918945312,
        168.55914306640625
      ],
      "bbox_max": [
        -2005.766357421875,
        -211.48477172851562,
        169.27537536621094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8849160075187683,
        0.3665442168712616,
        0.2873479723930359
      ],
      "plane_d": 1814.4259033203125,
      "bbox_min": [
        -2011.713134765625,
        -269.08624267578125,
        168.5591278076172
      ],
      "bbox_max": [
        -1993.7381591796875,
        -226.0835723876953,
        171.38514709472656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37525060772895813,
        0.9059386849403381,
        0.19611714780330658
      ],
      "plane_d": -687.8109130859375,
      "bbox_min": [
        -2230.0,
        -243.06231689453125,
        270.0
      ],
      "bbox_max": [
        -2138.0,
        -198.17042541503906,
        295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6933766603469849,
        0.6933737397193909,
        0.19611626863479614
      ],
      "plane_d": -1435.5511474609375,
      "bbox_min": [
        -2230.0,
        -243.06231689453125,
        270.0
      ],
      "bbox_max": [
        -2138.0,
        -198.17042541503906,
        295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6933767199516296,
        0.6933737993240356,
        0.19611559808254242
      ],
      "plane_d": 1545.96875,
      "bbox_min": [
        -2138.0,
        -244.2296600341797,
        270.0
      ],
      "bbox_max": [
        -2063.673095703125,
        -198.17042541503906,
        295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3752506673336029,
        0.9059388637542725,
        0.19611626863479614
      ],
      "plane_d": 925.7670288085938,
      "bbox_min": [
        -2138.0,
        -217.68331909179688,
        270.0
      ],
      "bbox_max": [
        -2092.318115234375,
        -198.17042541503906,
        295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9805806279182434,
        0.1961161196231842
      ],
      "plane_d": 141.3707275390625,
      "bbox_min": [
        -2138.0,
        -203.17042541503906,
        270.0
      ],
      "bbox_max": [
        -2129.744873046875,
        -198.17042541503906,
        295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9517086744308472,
        0.3070027828216553
      ],
      "plane_d": 85.46958923339844,
      "bbox_min": [
        -2160.0,
        -192.11070251464844,
        292.0
      ],
      "bbox_max": [
        -2138.0,
        -184.0,
        313.8330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2138.0,
      "bbox_min": [
        -2138.0,
        -192.11070251464844,
        292.0
      ],
      "bbox_max": [
        -2138.0,
        -184.0,
        305.904052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 134.1866455078125,
      "bbox_min": [
        -2680.8134765625,
        -173.53219604492188,
        274.0
      ],
      "bbox_max": [
        -2627.32568359375,
        -134.1866455078125,
        330.49847412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6351800560951233,
        -0.44592615962028503,
        0.6306314468383789
      ],
      "plane_d": 1418.4951171875,
      "bbox_min": [
        -2680.8134765625,
        -173.53219604492188,
        320.1879577636719
      ],
      "bbox_max": [
        -2658.35546875,
        -149.1866455078125,
        330.49847412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6351796984672546,
        0.4459250569343567,
        0.6306326985359192
      ],
      "plane_d": 1529.975341796875,
      "bbox_min": [
        -2680.8134765625,
        -100.81336975097656,
        312.95953369140625
      ],
      "bbox_max": [
        -2645.6923828125,
        -65.6922607421875,
        330.49847412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7926474809646606,
        0.0,
        0.6096802353858948
      ],
      "plane_d": 1923.4415283203125,
      "bbox_min": [
        -2680.8134765625,
        -100.81336975097656,
        312.95953369140625
      ],
      "bbox_max": [
        -2645.6923828125,
        -65.6922607421875,
        330.49847412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20758119225502014,
        0.6917053461074829,
        0.6917034983634949
      ],
      "plane_d": 397.6127014160156,
      "bbox_min": [
        -2659.83447265625,
        -100.81336975097656,
        312.95953369140625
      ],
      "bbox_max": [
        -2645.6923828125,
        -90.81336975097656,
        324.2026062011719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2579.5,
      "bbox_min": [
        -2579.5,
        -55.99999237060547,
        135.45835876464844
      ],
      "bbox_max": [
        -2579.5,
        -43.63885498046875,
        154.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6351800560951233,
        -0.44592615962028503,
        0.6306314468383789
      ],
      "plane_d": 1472.00634765625,
      "bbox_min": [
        -2680.8134765625,
        -75.69224548339844,
        312.95953369140625
      ],
      "bbox_max": [
        -2655.6923828125,
        -29.1866455078125,
        330.49847412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7926474809646606,
        0.0,
        0.6096802353858948
      ],
      "plane_d": 1923.4415283203125,
      "bbox_min": [
        -2680.8134765625,
        -75.69224548339844,
        317.4974365234375
      ],
      "bbox_max": [
        -2670.8134765625,
        -50.165618896484375,
        330.49847412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09447619318962097,
        0.9444399476051331,
        0.31481340527534485
      ],
      "plane_d": 285.4033203125,
      "bbox_min": [
        -2680.8134765625,
        -173.6656494140625,
        284.4466247558594
      ],
      "bbox_max": [
        -2627.32568359375,
        -134.1866455078125,
        330.49847412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6351800560951233,
        -0.44592615962028503,
        0.6306314468383789
      ],
      "plane_d": 1418.4951171875,
      "bbox_min": [
        -2680.8134765625,
        -173.6656494140625,
        312.95953369140625
      ],
      "bbox_max": [
        -2655.6923828125,
        -152.75741577148438,
        330.49847412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7926474809646606,
        0.0,
        0.6096802353858948
      ],
      "plane_d": 1923.4415283203125,
      "bbox_min": [
        -2680.8134765625,
        -173.6656494140625,
        329.9852294921875
      ],
      "bbox_max": [
        -2680.418701171875,
        -173.323486328125,
        330.49847412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7183197736740112,
        0.6292963624000549,
        0.2966524362564087
      ],
      "plane_d": 1875.7591552734375,
      "bbox_min": [
        -2642.32568359375,
        -158.6402130126953,
        277.3454284667969
      ],
      "bbox_max": [
        -2599.81982421875,
        -134.1866455078125,
        318.9482116699219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28743797540664673,
        4.9191739890375175e-06,
        0.9577993154525757
      ],
      "plane_d": 454.0171203613281,
      "bbox_min": [
        -2642.32568359375,
        -158.6402130126953,
        277.3454284667969
      ],
      "bbox_max": [
        -2599.81982421875,
        -134.1866455078125,
        318.9482116699219
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.35897907614707947,
        -0.0,
        0.9333456158638
      ],
      "plane_d": 777.9076538085938,
      "bbox_min": [
        -2570.0,
        -56.66666793823242,
        153.92007446289062
      ],
      "bbox_max": [
        -2567.192138671875,
        -53.1389045715332,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 38.0,
      "bbox_min": [
        -2608.952392578125,
        -43.63890075683594,
        100.0
      ],
      "bbox_max": [
        -2518.0,
        -14.1866455078125,
        155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2579.5,
      "bbox_min": [
        -2585.138916015625,
        -43.63890075683594,
        127.52066040039062
      ],
      "bbox_max": [
        -2518.0,
        -38.0,
        154.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        -2585.138916015625,
        -39.999996185302734,
        130.0
      ],
      "bbox_max": [
        -2579.5,
        -38.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2520.0,
      "bbox_min": [
        -2520.0,
        -40.0,
        127.52066040039062
      ],
      "bbox_max": [
        -2520.0,
        -38.0,
        130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9284767508506775,
        0.0,
        -0.3713906705379486
      ],
      "plane_d": 2388.042236328125,
      "bbox_min": [
        -2579.5,
        -43.33333969116211,
        130.0
      ],
      "bbox_max": [
        -2518.0,
        -38.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -131.0,
      "bbox_min": [
        -2579.5,
        -40.666664123535156,
        131.0
      ],
      "bbox_max": [
        -2572.0,
        -39.0,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        -2608.952392578125,
        -38.0,
        100.0
      ],
      "bbox_max": [
        -2570.0,
        -14.1866455078125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2570.0,
      "bbox_min": [
        -2570.0,
        -38.0,
        100.0
      ],
      "bbox_max": [
        -2570.0,
        -14.186673164367676,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5.0,
      "bbox_min": [
        -2859.0,
        -14.186673164367676,
        100.0
      ],
      "bbox_max": [
        -2547.5,
        13.75,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2859.0,
      "bbox_min": [
        -2859.0,
        12.5,
        100.0
      ],
      "bbox_max": [
        -2547.5,
        13.75,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2547.5,
      "bbox_min": [
        -2547.5,
        12.5,
        100.0
      ],
      "bbox_max": [
        -2547.5,
        13.75,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6343935132026672,
        0.7730103731155396,
        -0.0
      ],
      "plane_d": 1240.5682373046875,
      "bbox_min": [
        -2030.0,
        -46.0,
        100.0
      ],
      "bbox_max": [
        -1899.46728515625,
        13.75,
        139.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5753709673881531,
        0.7010922431945801,
        -0.42121005058288574
      ],
      "plane_d": 1181.5908203125,
      "bbox_min": [
        -2030.0,
        -42.66666793823242,
        100.0
      ],
      "bbox_max": [
        -1903.5289306640625,
        13.75,
        134.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2094.563720703125,
      "bbox_min": [
        -2094.563720703125,
        -8.705902099609375,
        234.0
      ],
      "bbox_max": [
        -2094.563720703125,
        13.75,
        253.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -15.0,
      "bbox_min": [
        -2861.5,
        13.75,
        100.0
      ],
      "bbox_max": [
        -2237.5,
        161.25,
        126.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2859.0,
      "bbox_min": [
        -2859.0,
        13.75,
        100.0
      ],
      "bbox_max": [
        -2547.5,
        15.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2547.5,
      "bbox_min": [
        -2547.5,
        13.75,
        100.0
      ],
      "bbox_max": [
        -2547.5,
        15.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2237.5,
      "bbox_min": [
        -2237.5,
        160.0,
        100.0
      ],
      "bbox_max": [
        -2237.5,
        161.25,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -162.5,
      "bbox_min": [
        -2240.0,
        162.5,
        100.0
      ],
      "bbox_max": [
        -2238.75,
        162.5,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2237.5,
      "bbox_min": [
        -2238.75,
        161.25,
        100.0
      ],
      "bbox_max": [
        -2237.5,
        196.25,
        126.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -162.5,
      "bbox_min": [
        -2238.75,
        162.5,
        100.0
      ],
      "bbox_max": [
        -2237.5,
        162.5,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9482250213623047,
        -0.2540792226791382,
        0.19055941700935364
      ],
      "plane_d": 2399.011962890625,
      "bbox_min": [
        -2490.0,
        325.0,
        125.0
      ],
      "bbox_max": [
        -2460.0,
        370.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20959734916687012,
        -0.7822301983833313,
        0.5866726636886597
      ],
      "plane_d": 702.7882080078125,
      "bbox_min": [
        -2490.0,
        325.0,
        125.0
      ],
      "bbox_max": [
        -2464.019287109375,
        355.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9578263759613037,
        0.2873479127883911
      ],
      "plane_d": -507.64801025390625,
      "bbox_min": [
        -2540.0,
        475.0,
        100.0
      ],
      "bbox_max": [
        -2468.786865234375,
        500.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2028038203716278,
        0.9792194366455078,
        0.0
      ],
      "plane_d": 25.16400146484375,
      "bbox_min": [
        -2490.0,
        489.5000305175781,
        133.33343505859375
      ],
      "bbox_max": [
        -2487.5859375,
        490.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43283241987228394,
        -0.5771098732948303,
        0.6925318241119385
      ],
      "plane_d": 1174.4185791015625,
      "bbox_min": [
        -2460.0,
        310.0,
        100.0
      ],
      "bbox_max": [
        -2440.0,
        500.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9578263759613037,
        0.2873479127883911
      ],
      "plane_d": -507.64801025390625,
      "bbox_min": [
        -2460.0,
        485.0,
        100.0
      ],
      "bbox_max": [
        -2440.0,
        500.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -474.9999694824219,
      "bbox_min": [
        -2440.0,
        475.0,
        100.0
      ],
      "bbox_max": [
        -2415.0,
        475.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2237.5,
      "bbox_min": [
        -2237.5,
        196.25,
        100.0
      ],
      "bbox_max": [
        -2237.5,
        197.5,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -340.0,
      "bbox_min": [
        -1924.5,
        338.7499084472656,
        100.0
      ],
      "bbox_max": [
        -1923.1798095703125,
        340.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -126.0,
      "bbox_min": [
        -1924.5,
        338.7499084472656,
        126.0
      ],
      "bbox_max": [
        -1923.1798095703125,
        340.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2104.563720703125,
      "bbox_min": [
        -2174.14208984375,
        13.75,
        100.0
      ],
      "bbox_max": [
        -1922.0,
        338.75,
        253.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -66.84466552734375,
      "bbox_min": [
        -2174.14208984375,
        45.550559997558594,
        100.0
      ],
      "bbox_max": [
        -2104.563720703125,
        161.25,
        253.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071054577827454,
        0.707108199596405,
        -0.0
      ],
      "plane_d": 1455.9393310546875,
      "bbox_min": [
        -2125.85791015625,
        45.550559997558594,
        234.0
      ],
      "bbox_max": [
        -2104.563720703125,
        66.84466552734375,
        253.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -161.25,
      "bbox_min": [
        -2111.96484375,
        161.25,
        100.0
      ],
      "bbox_max": [
        -2104.563720703125,
        161.25,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1425.7041015625,
      "bbox_min": [
        -2104.563720703125,
        13.75,
        100.0
      ],
      "bbox_max": [
        -1922.0,
        338.75,
        253.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -161.25,
      "bbox_min": [
        -2104.563720703125,
        161.25,
        100.0
      ],
      "bbox_max": [
        -1922.0,
        338.75,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1922.0,
      "bbox_min": [
        -1924.5,
        337.5,
        100.0
      ],
      "bbox_max": [
        -1922.0,
        338.75,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -126.0,
      "bbox_min": [
        -1924.5,
        337.5,
        126.0
      ],
      "bbox_max": [
        -1922.0,
        338.75,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1922.0,
      "bbox_min": [
        -1924.5,
        338.7499084472656,
        100.0
      ],
      "bbox_max": [
        -1922.0,
        340.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -340.0,
      "bbox_min": [
        -1924.5,
        338.7499084472656,
        100.0
      ],
      "bbox_max": [
        -1922.0,
        340.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -126.0,
      "bbox_min": [
        -1924.5,
        338.7499084472656,
        126.0
      ],
      "bbox_max": [
        -1922.0,
        340.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4163157343864441,
        0.8524560332298279,
        0.3162277638912201
      ],
      "plane_d": 939.8093872070312,
      "bbox_min": [
        -1127.99072265625,
        -2033.634033203125,
        -300.0
      ],
      "bbox_max": [
        -157.67498779296875,
        -1068.1884765625,
        169.8988800048828
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18530525267124176,
        0.5702676773071289,
        0.8002853393554688
      ],
      "plane_d": 680.0791015625,
      "bbox_min": [
        -1127.150390625,
        -1650.1837158203125,
        -85.06402587890625
      ],
      "bbox_max": [
        -826.8541259765625,
        -1461.2427978515625,
        80.53498077392578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7835570573806763,
        0.1681862473487854,
        0.5981235504150391
      ],
      "plane_d": -601.2240600585938,
      "bbox_min": [
        -1127.150390625,
        -1650.1837158203125,
        -85.06402587890625
      ],
      "bbox_max": [
        -1059.9925537109375,
        -1528.0806884765625,
        80.53497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.927556574344635,
        0.1990949660539627,
        0.31622761487960815
      ],
      "plane_d": -711.715087890625,
      "bbox_min": [
        -1127.150390625,
        -1650.1837158203125,
        -85.06402587890625
      ],
      "bbox_max": [
        -1100.0,
        -1528.0806884765625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5815920829772949,
        0.8134806156158447
      ],
      "plane_d": 463.345703125,
      "bbox_min": [
        -4205.0,
        -5072.0185546875,
        -300.0
      ],
      "bbox_max": [
        7823.75537109375,
        -696.68505859375,
        2100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.60302734375,
      "bbox_min": [
        -3461.15576171875,
        -5072.0185546875,
        1212.388916015625
      ],
      "bbox_max": [
        -2147.99658203125,
        -4521.4228515625,
        1390.116943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -1549.2021484375,
        -3672.376220703125,
        0.0
      ],
      "bbox_max": [
        334.5896301269531,
        -2051.8349609375,
        892.7235107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7320768237113953,
        0.5631359815597534,
        0.38332945108413696
      ],
      "plane_d": 259.0802001953125,
      "bbox_min": [
        -1549.2021484375,
        -2765.516357421875,
        202.6451416015625
      ],
      "bbox_max": [
        -1145.6080322265625,
        -2051.8349609375,
        445.481201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -1549.2021484375,
        -2765.516357421875,
        202.6451416015625
      ],
      "bbox_max": [
        -1145.6080322265625,
        -2051.8349609375,
        445.481201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5844033360481262,
        0.7305042147636414,
        0.35332190990448
      ],
      "plane_d": 957.4642333984375,
      "bbox_min": [
        -1549.2021484375,
        -2765.516357421875,
        435.46630859375
      ],
      "bbox_max": [
        -1527.4627685546875,
        -2745.02197265625,
        445.481201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4163157343864441,
        0.8524560332298279,
        0.3162277638912201
      ],
      "plane_d": 939.8093872070312,
      "bbox_min": [
        -794.8798828125,
        -1446.0003662109375,
        -300.0
      ],
      "bbox_max": [
        2861.488525390625,
        -698.838623046875,
        305.0291748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999567866325378,
        0.007047934457659721,
        -0.006074882112443447
      ],
      "plane_d": 2864.507080078125,
      "bbox_min": [
        1763.2515869140625,
        -1223.359130859375,
        -293.53936767578125
      ],
      "bbox_max": [
        2861.488525390625,
        -698.838623046875,
        305.0291748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29317936301231384,
        0.9022449254989624,
        0.31622767448425293
      ],
      "plane_d": 1075.9822998046875,
      "bbox_min": [
        -794.8798828125,
        -1446.0003662109375,
        -113.20272827148438
      ],
      "bbox_max": [
        -551.24462890625,
        -1336.6162109375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18530525267124176,
        0.5702676773071289,
        0.8002853393554688
      ],
      "plane_d": 680.0791015625,
      "bbox_min": [
        -1074.1181640625,
        -2039.7471923828125,
        -13.845283508300781
      ],
      "bbox_max": [
        -504.59906005859375,
        -1371.68505859375,
        256.8197326660156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -681.8506469726562,
        -1625.7083740234375,
        0.0
      ],
      "bbox_max": [
        -504.59906005859375,
        -1371.68505859375,
        150.77035522460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999809861183167,
        0.0010614438215270638,
        -0.006073073484003544
      ],
      "plane_d": 1764.6995849609375,
      "bbox_min": [
        1763.1832275390625,
        -927.0469970703125,
        5.1944966316223145
      ],
      "bbox_max": [
        1763.848388671875,
        -803.9506225585938,
        93.2012710571289
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7320768237113953,
        0.5631359815597534,
        0.38332945108413696
      ],
      "plane_d": 259.0802001953125,
      "bbox_min": [
        -1939.5809326171875,
        -3110.410400390625,
        252.59999084472656
      ],
      "bbox_max": [
        -1146.2474365234375,
        -2061.892333984375,
        636.4718627929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4769039750099182,
        0.7969357371330261,
        0.37075066566467285
      ],
      "plane_d": 1317.8309326171875,
      "bbox_min": [
        -1939.5809326171875,
        -3110.410400390625,
        252.59999084472656
      ],
      "bbox_max": [
        -1146.2474365234375,
        -2061.892333984375,
        636.4718627929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5844033360481262,
        0.7305042147636414,
        0.35332190990448
      ],
      "plane_d": 957.4642333984375,
      "bbox_min": [
        -1655.49462890625,
        -2909.402099609375,
        252.59999084472656
      ],
      "bbox_max": [
        -1146.2474365234375,
        -2061.892333984375,
        579.1570434570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -1174.739013671875,
        -2196.100341796875,
        252.59999084472656
      ],
      "bbox_max": [
        -1146.2474365234375,
        -2061.892333984375,
        310.4968566894531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7835570573806763,
        0.1681862473487854,
        0.5981235504150391
      ],
      "plane_d": -601.2240600585938,
      "bbox_min": [
        -1009.5068969726562,
        -2039.88671875,
        252.60015869140625
      ],
      "bbox_max": [
        -1007.595458984375,
        -2026.73095703125,
        258.803466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3156070411205292,
        0.8320549726486206,
        0.45615431666374207
      ],
      "plane_d": 1686.0640869140625,
      "bbox_min": [
        -2286.8662109375,
        -3399.51513671875,
        251.769287109375
      ],
      "bbox_max": [
        -1088.6651611328125,
        -2059.143798828125,
        1050.8297119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5844033360481262,
        0.7305042147636414,
        0.35332190990448
      ],
      "plane_d": 957.4642333984375,
      "bbox_min": [
        -1648.24072265625,
        -3047.155029296875,
        251.769287109375
      ],
      "bbox_max": [
        -1088.6651611328125,
        -2059.143798828125,
        914.7692260742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -1172.828125,
        -2377.942626953125,
        251.769287109375
      ],
      "bbox_max": [
        -1088.6651611328125,
        -2059.143798828125,
        634.215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -1018.4613037109375,
        -2110.8046875,
        137.07241821289062
      ],
      "bbox_max": [
        -436.7973327636719,
        -1565.9052734375,
        530.965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7835570573806763,
        0.1681862473487854,
        0.5981235504150391
      ],
      "plane_d": -601.2240600585938,
      "bbox_min": [
        -1012.9479370117188,
        -2050.0,
        218.60536193847656
      ],
      "bbox_max": [
        -900.0,
        -1921.8660888671875,
        402.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18530525267124176,
        0.5702676773071289,
        0.8002853393554688
      ],
      "plane_d": 680.0791015625,
      "bbox_min": [
        -1018.4613037109375,
        -2050.0,
        150.7703399658203
      ],
      "bbox_max": [
        -681.8505859375,
        -1625.7083740234375,
        402.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        544.5404663085938,
        -1746.0208740234375,
        252.5999755859375
      ],
      "bbox_max": [
        1019.5870971679688,
        -1600.0,
        431.56463623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -614.9921264648438,
        -1691.1807861328125,
        114.45515441894531
      ],
      "bbox_max": [
        650.0,
        -1467.1614990234375,
        376.37713623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -614.9921264648438,
        -1689.80029296875,
        114.45515441894531
      ],
      "bbox_max": [
        -411.225341796875,
        -1467.1614990234375,
        356.619873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7320768237113953,
        0.5631359815597534,
        0.38332945108413696
      ],
      "plane_d": 259.0802001953125,
      "bbox_min": [
        -3625.179443359375,
        -3623.86962890625,
        509.4501037597656
      ],
      "bbox_max": [
        -1001.381103515625,
        -2097.481689453125,
        1652.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5160083770751953,
        0.7518967390060425,
        0.41034960746765137
      ],
      "plane_d": 1040.8974609375,
      "bbox_min": [
        -2100.0,
        -3623.86962890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -1550.0,
        -3350.0,
        1652.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31618040800094604,
        0.5486864447593689,
        0.7739335298538208
      ],
      "plane_d": -131.23565673828125,
      "bbox_min": [
        -3625.179443359375,
        -3619.13720703125,
        1037.2603759765625
      ],
      "bbox_max": [
        -2988.559814453125,
        -3212.1396484375,
        1420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965404748916626,
        -0.2439502775669098,
        0.09209758043289185
      ],
      "plane_d": 2003.1627197265625,
      "bbox_min": [
        -3058.93505859375,
        -3479.345703125,
        1037.2603759765625
      ],
      "bbox_max": [
        -2988.559814453125,
        -3212.1396484375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011314941570162773,
        0.9574529528617859,
        0.2883673906326294
      ],
      "plane_d": 3096.69091796875,
      "bbox_min": [
        -3625.179443359375,
        -3619.13720703125,
        1274.598876953125
      ],
      "bbox_max": [
        -3260.67529296875,
        -3576.798583984375,
        1420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6317505836486816,
        0.763104259967804,
        0.13624615967273712
      ],
      "plane_d": 4182.1328125,
      "bbox_min": [
        -3070.88916015625,
        -3408.1083984375,
        1030.70751953125
      ],
      "bbox_max": [
        -2099.20068359375,
        -3126.308349609375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965404748916626,
        -0.2439502775669098,
        0.09209758043289185
      ],
      "plane_d": 2003.1627197265625,
      "bbox_min": [
        -3003.01416015625,
        -3223.927001953125,
        1030.70751953125
      ],
      "bbox_max": [
        -2981.017578125,
        -3196.55322265625,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -2144.1455078125,
        -3408.1083984375,
        1050.490234375
      ],
      "bbox_max": [
        -2099.20068359375,
        -3398.540283203125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3156070411205292,
        0.8320549726486206,
        0.45615431666374207
      ],
      "plane_d": 1686.0640869140625,
      "bbox_min": [
        -2101.2802734375,
        -3400.0,
        1050.490234375
      ],
      "bbox_max": [
        -2099.20068359375,
        -3398.540283203125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        -778.3905029296875,
        -2403.4306640625,
        444.7264404296875
      ],
      "bbox_max": [
        1109.864501953125,
        -1902.55712890625,
        1148.731201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -778.3905029296875,
        -2403.4306640625,
        444.7264404296875
      ],
      "bbox_max": [
        -166.50149536132812,
        -1902.55712890625,
        1148.731201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -476.1239929199219,
        -2318.328857421875,
        595.6363525390625
      ],
      "bbox_max": [
        360.59344482421875,
        -1980.4971923828125,
        1087.8883056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -164.90333557128906,
        -2234.215087890625,
        742.3648681640625
      ],
      "bbox_max": [
        360.59344482421875,
        -2000.7166748046875,
        1027.7518310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -3652.813720703125,
        -2586.1181640625,
        356.619873046875
      ],
      "bbox_max": [
        -164.9033203125,
        -1689.80029296875,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -3652.813720703125,
        -2586.1181640625,
        793.7976684570312
      ],
      "bbox_max": [
        -869.4028930664062,
        -2139.787109375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -3652.813720703125,
        -2586.1181640625,
        793.7976684570312
      ],
      "bbox_max": [
        -987.1666259765625,
        -2139.787353515625,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3652.813720703125,
        -2586.1181640625,
        1152.9107666015625
      ],
      "bbox_max": [
        -3528.30859375,
        -2436.3173828125,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -987.384765625,
        -2188.843505859375,
        967.7686157226562
      ],
      "bbox_max": [
        -963.984130859375,
        -2165.6708984375,
        995.3135986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -987.384765625,
        -2187.933349609375,
        967.7688598632812
      ],
      "bbox_max": [
        -984.6701049804688,
        -2165.6708984375,
        994.6629028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -436.7973327636719,
        -1732.9390869140625,
        343.5681457519531
      ],
      "bbox_max": [
        -52.859130859375,
        -1658.283447265625,
        433.06378173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -436.7973327636719,
        -1732.9390869140625,
        343.56817626953125
      ],
      "bbox_max": [
        -374.75189208984375,
        -1658.283447265625,
        433.06378173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -1247.748291015625,
        -3334.0634765625,
        1087.8883056640625
      ],
      "bbox_max": [
        85.42315673828125,
        -2318.328857421875,
        1814.080322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -1247.748291015625,
        -3108.19873046875,
        1179.737548828125
      ],
      "bbox_max": [
        -560.601318359375,
        -2446.799560546875,
        1656.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -713.9907836914062,
        -2605.074951171875,
        1179.737548828125
      ],
      "bbox_max": [
        -560.601318359375,
        -2446.799560546875,
        1347.8153076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5844033360481262,
        0.7305042147636414,
        0.35332190990448
      ],
      "plane_d": 957.4642333984375,
      "bbox_min": [
        -1247.748291015625,
        -3108.19873046875,
        1463.5894775390625
      ],
      "bbox_max": [
        -1050.0,
        -2843.8271484375,
        1652.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -193.138916015625,
        -2500.0,
        1087.8883056640625
      ],
      "bbox_max": [
        0.0,
        -2318.328857421875,
        1352.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -1027.7886962890625,
        -2691.334228515625,
        1018.5446166992188
      ],
      "bbox_max": [
        0.0,
        -2221.3369140625,
        1460.001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -869.4028930664062,
        -2604.275390625,
        1018.5446166992188
      ],
      "bbox_max": [
        0.0,
        -2221.3369140625,
        1411.1329345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -869.4028930664062,
        -2604.275390625,
        1065.087646484375
      ],
      "bbox_max": [
        -556.1375122070312,
        -2286.437255859375,
        1411.1329345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -602.8601684570312,
        -2604.275390625,
        1347.8155517578125
      ],
      "bbox_max": [
        -556.1375122070312,
        -2552.3193359375,
        1411.1329345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -4128.15283203125,
        -2962.61669921875,
        1113.0570068359375
      ],
      "bbox_max": [
        -233.89080810546875,
        -2312.367919921875,
        1774.980712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8395622968673706,
        0.49151238799095154,
        0.231409952044487
      ],
      "plane_d": 4493.8125,
      "bbox_min": [
        -4128.15283203125,
        -2759.122802734375,
        1395.3641357421875
      ],
      "bbox_max": [
        -4123.98779296875,
        -2748.399658203125,
        1403.0306396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        -1001.381103515625,
        -2397.92236328125,
        749.0462646484375
      ],
      "bbox_max": [
        2400.0,
        -1844.385986328125,
        1239.5428466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022904695942997932,
        0.8625975847244263,
        0.5053718686103821
      ],
      "plane_d": 1267.3873291015625,
      "bbox_min": [
        1721.03564453125,
        -2050.0,
        749.0462646484375
      ],
      "bbox_max": [
        2400.0,
        -1844.385986328125,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -1001.381103515625,
        -2397.92236328125,
        980.05322265625
      ],
      "bbox_max": [
        -773.8843994140625,
        -2167.49853515625,
        1239.5428466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -1001.381103515625,
        -2397.92236328125,
        980.05322265625
      ],
      "bbox_max": [
        -973.9005126953125,
        -2167.49853515625,
        1239.5428466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.02753951959311962,
        0.7068385481834412,
        0.7068385481834412
      ],
      "plane_d": 737.5914916992188,
      "bbox_min": [
        2400.0,
        -2050.0,
        231.39405822753906
      ],
      "bbox_max": [
        7600.0,
        -1120.3388671875,
        1152.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.41241455078125,
      "bbox_min": [
        2455.532470703125,
        -1350.0,
        231.39405822753906
      ],
      "bbox_max": [
        7600.0,
        -1120.3388671875,
        602.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999567866325378,
        0.007047934457659721,
        -0.006074882112443447
      ],
      "plane_d": 2864.507080078125,
      "bbox_min": [
        2854.1337890625,
        -1223.3333740234375,
        231.39405822753906
      ],
      "bbox_max": [
        2855.32861328125,
        -1120.3388671875,
        308.560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999567866325378,
        0.007047934457659721,
        -0.006074882112443447
      ],
      "plane_d": 2864.507080078125,
      "bbox_min": [
        2853.9306640625,
        -1223.333251953125,
        283.2035217285156
      ],
      "bbox_max": [
        2854.681640625,
        -1167.4876708984375,
        341.997802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -4205.0,
        -2915.38232421875,
        252.5999755859375
      ],
      "bbox_max": [
        2854.1474609375,
        -1150.0,
        1770.0086669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -973.9005126953125,
        -2915.38232421875,
        252.5999755859375
      ],
      "bbox_max": [
        2854.1474609375,
        -1150.0,
        1770.0086669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8705313205718994,
        0.4785127639770508,
        0.11489474773406982
      ],
      "plane_d": 4224.23291015625,
      "bbox_min": [
        -3712.849365234375,
        -2384.524658203125,
        1181.5667724609375
      ],
      "bbox_max": [
        -3697.73974609375,
        -2363.246337890625,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7499687671661377,
        0.6611047983169556,
        -0.022072862833738327
      ],
      "plane_d": 4375.75,
      "bbox_min": [
        -3712.849365234375,
        -2384.524658203125,
        1182.310546875
      ],
      "bbox_max": [
        -3697.797607421875,
        -2366.191162109375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3712.849365234375,
        -2378.30322265625,
        1210.55859375
      ],
      "bbox_max": [
        -3702.450439453125,
        -2366.191162109375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3725.179443359375,
        -2503.115234375,
        1172.2432861328125
      ],
      "bbox_max": [
        -3597.956298828125,
        -2323.558349609375,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9880585670471191,
        0.11992283910512924,
        0.09674030542373657
      ],
      "plane_d": 3834.249755859375,
      "bbox_min": [
        -3725.179443359375,
        -2329.201904296875,
        1179.126708984375
      ],
      "bbox_max": [
        -3714.01416015625,
        -2323.558349609375,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -909.1630249023438,
        -2564.65576171875,
        5.1944966316223145
      ],
      "bbox_max": [
        1763.854248046875,
        -798.4165649414062,
        1733.090087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -903.2229614257812,
        -2564.65576171875,
        5.1944966316223145
      ],
      "bbox_max": [
        1763.854248046875,
        -798.4165649414062,
        1733.090087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -825.0,
        -2564.65576171875,
        1547.93359375
      ],
      "bbox_max": [
        -575.9976196289062,
        -2275.0,
        1733.090087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999809861183167,
        0.0010614438215270638,
        -0.006073073484003544
      ],
      "plane_d": 1764.6995849609375,
      "bbox_min": [
        1762.5565185546875,
        -927.0469360351562,
        5.1944966316223145
      ],
      "bbox_max": [
        1763.854248046875,
        -798.4165649414062,
        196.3846893310547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        -4020.98193359375,
        4947.96533203125,
        -300.0
      ],
      "bbox_max": [
        943.3017578125,
        7287.82421875,
        615.3095092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9449668526649475,
        0.08389011770486832,
        0.3162277042865753
      ],
      "plane_d": -187.74609375,
      "bbox_min": [
        140.185791015625,
        4947.96533203125,
        -300.0
      ],
      "bbox_max": [
        588.0418701171875,
        7287.82421875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7881146669387817,
        0.06996545940637589,
        0.6115390658378601
      ],
      "plane_d": -136.38499450683594,
      "bbox_min": [
        249.411865234375,
        5047.4609375,
        -33.027774810791016
      ],
      "bbox_max": [
        588.0418701171875,
        7287.82421875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3932375907897949,
        -0.4582340121269226,
        0.797110915184021
      ],
      "plane_d": 2052.83154296875,
      "bbox_min": [
        -2582.97119140625,
        5654.2333984375,
        150.0
      ],
      "bbox_max": [
        943.3017578125,
        7262.134765625,
        615.3095092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0844237431883812,
        -0.9449194669723511,
        0.31622740626335144
      ],
      "plane_d": 5014.3017578125,
      "bbox_min": [
        3040.46826171875,
        4858.1806640625,
        -300.0
      ],
      "bbox_max": [
        3966.75,
        5034.5224609375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        -3988.779052734375,
        -321.70458984375,
        -300.0
      ],
      "bbox_max": [
        6306.5068359375,
        7196.82421875,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0844237431883812,
        -0.9449194669723511,
        0.31622740626335144
      ],
      "plane_d": 5014.3017578125,
      "bbox_min": [
        3956.6728515625,
        4947.60009765625,
        -13.693603515625
      ],
      "bbox_max": [
        3970.173828125,
        4951.876953125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028518805280327797,
        -0.31919899582862854,
        0.947258472442627
      ],
      "plane_d": 1693.8587646484375,
      "bbox_min": [
        2769.303955078125,
        4948.55078125,
        -13.543867111206055
      ],
      "bbox_max": [
        3970.173828125,
        7185.4150390625,
        723.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        2769.303955078125,
        4948.55078125,
        -13.543867111206055
      ],
      "bbox_max": [
        3970.173828125,
        7185.4150390625,
        723.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0844237431883812,
        -0.9449194669723511,
        0.31622740626335144
      ],
      "plane_d": 5014.3017578125,
      "bbox_min": [
        3955.45556640625,
        4948.55078125,
        -13.543867111206055
      ],
      "bbox_max": [
        3970.173828125,
        4951.876953125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004390379413962364,
        -0.9486730098724365,
        0.31622809171676636
      ],
      "plane_d": 4789.4853515625,
      "bbox_min": [
        -2975.755615234375,
        -321.70458984375,
        -300.0
      ],
      "bbox_max": [
        4399.7919921875,
        5561.64794921875,
        150.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028518805280327797,
        -0.31919899582862854,
        0.947258472442627
      ],
      "plane_d": 1693.8587646484375,
      "bbox_min": [
        235.99966430664062,
        5034.5224609375,
        -36.837890625
      ],
      "bbox_max": [
        3923.18212890625,
        5561.64794921875,
        150.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        2532.767578125,
        5034.5224609375,
        0.0
      ],
      "bbox_max": [
        3045.157470703125,
        5561.64794921875,
        150.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9449668526649475,
        0.08389011770486832,
        0.3162277042865753
      ],
      "plane_d": -187.74609375,
      "bbox_min": [
        235.99966430664062,
        5035.24365234375,
        -36.837890625
      ],
      "bbox_max": [
        259.23272705078125,
        5158.08642578125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0844237431883812,
        -0.9449194669723511,
        0.31622740626335144
      ],
      "plane_d": 5014.3017578125,
      "bbox_min": [
        3045.157470703125,
        4116.14306640625,
        -13.525781631469727
      ],
      "bbox_max": [
        4302.4873046875,
        5039.8720703125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10106618702411652,
        -0.9432844519615173,
        0.3162279725074768
      ],
      "plane_d": 3427.828369140625,
      "bbox_min": [
        -2657.889892578125,
        1023.302490234375,
        -300.0
      ],
      "bbox_max": [
        896.0,
        3913.755859375,
        60.000003814697266
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9805806279182434,
        0.0,
        0.1961161345243454
      ],
      "plane_d": 866.8333129882812,
      "bbox_min": [
        884.0,
        2404.0,
        0.0
      ],
      "bbox_max": [
        896.0,
        2716.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486832618713379,
        0.3162277638912201
      ],
      "plane_d": 1992.23486328125,
      "bbox_min": [
        -1839.6396484375,
        1912.0106201171875,
        -253.49160766601562
      ],
      "bbox_max": [
        -1445.5028076171875,
        2100.0,
        22.930442810058594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9151937961578369,
        -0.3909720778465271,
        -0.09778133779764175
      ],
      "plane_d": 683.7200927734375,
      "bbox_min": [
        -1537.6434326171875,
        1023.302490234375,
        -300.0
      ],
      "bbox_max": [
        208.00323486328125,
        2100.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7888013124465942,
        0.5270602107048035,
        0.3162277936935425
      ],
      "plane_d": -754.0639038085938,
      "bbox_min": [
        55.53363800048828,
        1630.9676513671875,
        -300.0
      ],
      "bbox_max": [
        208.00323486328125,
        1814.0926513671875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9440768361091614,
        -0.09337516874074936,
        0.3162277936935425
      ],
      "plane_d": -493.8998718261719,
      "bbox_min": [
        -754.0657958984375,
        1023.302490234375,
        -300.0
      ],
      "bbox_max": [
        62.046356201171875,
        1693.8050537109375,
        -178.35525512695312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8234102129936218,
        -0.4711642265319824,
        0.3162277936935425
      ],
      "plane_d": 8.160400390625,
      "bbox_min": [
        -731.9619750976562,
        1023.302490234375,
        -300.0
      ],
      "bbox_max": [
        62.046356201171875,
        1693.8050537109375,
        -228.5707244873047
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 2100.0,
      "bbox_min": [
        -1537.6434326171875,
        2100.0,
        0.0
      ],
      "bbox_max": [
        -1530.0,
        2100.0,
        24.184972763061523
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9151937365531921,
        -0.3909720182418823,
        -0.09778167307376862
      ],
      "plane_d": 1994.4017333984375,
      "bbox_min": [
        -2975.755615234375,
        500.97760009765625,
        60.0
      ],
      "bbox_max": [
        4399.7919921875,
        4966.6630859375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10106618702411652,
        -0.9432844519615173,
        0.3162279725074768
      ],
      "plane_d": 3427.828369140625,
      "bbox_min": [
        -2975.755615234375,
        1571.6395263671875,
        60.0
      ],
      "bbox_max": [
        900.0,
        3934.389892578125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40394648909568787,
        -0.8583862781524658,
        0.31622806191444397
      ],
      "plane_d": 3509.28515625,
      "bbox_min": [
        -1263.684326171875,
        3519.528076171875,
        60.0
      ],
      "bbox_max": [
        -417.7394104003906,
        3934.389892578125,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9151937961578369,
        -0.3909720778465271,
        -0.09778133779764175
      ],
      "plane_d": 683.7200927734375,
      "bbox_min": [
        -2975.755615234375,
        1571.6395263671875,
        60.0
      ],
      "bbox_max": [
        900.0,
        3398.1728515625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9805806279182434,
        0.0,
        0.1961161345243454
      ],
      "plane_d": 866.8333129882812,
      "bbox_min": [
        896.0,
        2400.0,
        60.0
      ],
      "bbox_max": [
        900.0,
        2704.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -2975.755615234375,
        3160.571044921875,
        124.09432983398438
      ],
      "bbox_max": [
        -2669.724609375,
        3398.1728515625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        -3086.993408203125,
        710.4066162109375,
        150.0
      ],
      "bbox_max": [
        3720.545654296875,
        7196.82421875,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3932375907897949,
        -0.4582340121269226,
        0.797110915184021
      ],
      "plane_d": 2052.83154296875,
      "bbox_min": [
        -3086.993408203125,
        710.4066162109375,
        150.0
      ],
      "bbox_max": [
        2868.99169921875,
        6954.4736328125,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9151937365531921,
        -0.3909720182418823,
        -0.09778167307376862
      ],
      "plane_d": 1994.4017333984375,
      "bbox_min": [
        -3086.993408203125,
        710.4066162109375,
        150.0
      ],
      "bbox_max": [
        2868.99169921875,
        3398.1728515625,
        781.7308349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999567866325378,
        0.007047934457659721,
        -0.006074882112443447
      ],
      "plane_d": 2864.507080078125,
      "bbox_min": [
        2868.726806640625,
        710.4066162109375,
        150.0
      ],
      "bbox_max": [
        2868.99169921875,
        748.0087890625,
        166.15914916992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -3086.993408203125,
        1826.806884765625,
        150.0
      ],
      "bbox_max": [
        -49.363739013671875,
        3398.1728515625,
        268.421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9151937961578369,
        -0.3909720778465271,
        -0.09778133779764175
      ],
      "plane_d": 683.7200927734375,
      "bbox_min": [
        -98.75617980957031,
        1826.806884765625,
        150.0
      ],
      "bbox_max": [
        -49.363739013671875,
        1934.499755859375,
        187.47412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9151937365531921,
        -0.3909720182418823,
        -0.09778167307376862
      ],
      "plane_d": 1994.4017333984375,
      "bbox_min": [
        -4912.15185546875,
        -1003.4161376953125,
        -300.0
      ],
      "bbox_max": [
        2868.8935546875,
        3224.859619140625,
        1140.47607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -1880.0,
        1750.0,
        -30.0
      ],
      "bbox_max": [
        -1840.0,
        1950.0,
        60.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1949.9998779296875,
      "bbox_min": [
        -1880.0,
        1750.0,
        -30.0
      ],
      "bbox_max": [
        -1840.0,
        1950.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1949.9998779296875,
      "bbox_min": [
        -1880.0,
        1750.0,
        0.0
      ],
      "bbox_max": [
        -1850.0,
        1950.0,
        60.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        -1880.0,
        1750.0,
        0.0
      ],
      "bbox_max": [
        -1850.0001220703125,
        1750.0,
        60.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486832618713379,
        0.3162277638912201
      ],
      "plane_d": 1261.748779296875,
      "bbox_min": [
        -1877.876708984375,
        1326.306884765625,
        -11.079254150390625
      ],
      "bbox_max": [
        -1846.306884765625,
        1330.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        -1870.0,
        1330.0,
        0.0
      ],
      "bbox_max": [
        -1850.0,
        1950.0,
        60.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1949.9998779296875,
      "bbox_min": [
        -1870.0,
        1950.0,
        0.0
      ],
      "bbox_max": [
        -1850.0,
        1950.0,
        60.000003814697266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1330.0,
      "bbox_min": [
        -1870.0,
        1330.0,
        0.0
      ],
      "bbox_max": [
        -1850.0,
        1330.0,
        60.000003814697266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1949.9998779296875,
      "bbox_min": [
        -1850.0001220703125,
        1750.0,
        -30.0
      ],
      "bbox_max": [
        -1840.0,
        1950.0,
        60.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        -1850.0001220703125,
        1750.0,
        -30.0
      ],
      "bbox_max": [
        -1840.0,
        1750.0,
        60.000003814697266
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 2100.0,
      "bbox_min": [
        -1779.8421630859375,
        2100.0,
        0.0
      ],
      "bbox_max": [
        -1749.4398193359375,
        2100.0,
        60.000003814697266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9440768361091614,
        -0.09337516874074936,
        0.3162277936935425
      ],
      "plane_d": -493.8998718261719,
      "bbox_min": [
        -719.397705078125,
        1180.1796875,
        -237.38377380371094
      ],
      "bbox_max": [
        -635.3445434570312,
        1315.3206787109375,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9805806875228882,
        0.0,
        0.1961161494255066
      ],
      "plane_d": -502.05731201171875,
      "bbox_min": [
        -619.3822631835938,
        639.4815673828125,
        0.0
      ],
      "bbox_max": [
        -500.0,
        1099.7568359375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9016833901405334,
        -0.38536393642425537,
        0.19611597061157227
      ],
      "plane_d": -118.8335189819336,
      "bbox_min": [
        -619.3822631835938,
        889.6224365234375,
        0.0
      ],
      "bbox_max": [
        -500.0,
        1099.7568359375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8510952591896057,
        -0.48700660467147827,
        0.19611585140228271
      ],
      "plane_d": 8.43547248840332,
      "bbox_min": [
        -619.3822631835938,
        978.4100341796875,
        0.0
      ],
      "bbox_max": [
        -539.185302734375,
        1099.7568359375,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.97581946849823,
        -0.09651471674442291,
        0.1961158812046051
      ],
      "plane_d": -510.5062255859375,
      "bbox_min": [
        -641.163330078125,
        639.4815673828125,
        0.0
      ],
      "bbox_max": [
        -500.0,
        1256.204833984375,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9486832618713379,
        0.3162277638912201
      ],
      "plane_d": 1992.23486328125,
      "bbox_min": [
        -1749.4398193359375,
        1099.7568359375,
        -12.840713500976562
      ],
      "bbox_max": [
        -608.0948486328125,
        2100.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8510953783988953,
        -0.4870060086250305,
        0.19611652195453644
      ],
      "plane_d": 8.434783935546875,
      "bbox_min": [
        -634.5513305664062,
        1099.7568359375,
        0.0
      ],
      "bbox_max": [
        -608.0948486328125,
        1149.4739990234375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.97581946849823,
        -0.09651471674442291,
        0.1961158812046051
      ],
      "plane_d": -510.5062255859375,
      "bbox_min": [
        -634.5513305664062,
        1126.266357421875,
        0.0
      ],
      "bbox_max": [
        -622.862060546875,
        1149.4739990234375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9974586963653564,
        0.07124704867601395
      ],
      "plane_d": 2080.4140625,
      "bbox_min": [
        -1870.0,
        2100.0,
        200.0
      ],
      "bbox_max": [
        -1850.7816162109375,
        2102.3271484375,
        232.58013916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1950.0,
      "bbox_min": [
        -1851.7857666015625,
        1750.0,
        199.99978637695312
      ],
      "bbox_max": [
        -1850.0,
        1950.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        -1851.7857666015625,
        1750.0,
        199.99978637695312
      ],
      "bbox_max": [
        -1850.0,
        1750.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        -1840.0,
        1750.0,
        150.0
      ],
      "bbox_max": [
        -1820.0,
        1950.0,
        225.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1950.0,
      "bbox_min": [
        -1840.0,
        1950.0,
        150.0
      ],
      "bbox_max": [
        -1820.0,
        1950.0,
        225.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -1614.9998779296875,
      "bbox_min": [
        -1655.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        -1580.0,
        575.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 530.0,
      "bbox_min": [
        -1615.0,
        530.0,
        60.0
      ],
      "bbox_max": [
        -1580.0,
        530.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1655.0,
      "bbox_min": [
        -1655.0,
        530.0,
        60.0
      ],
      "bbox_max": [
        -1625.0,
        575.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": -360.55517578125,
      "bbox_min": [
        -1645.0,
        530.0,
        60.0
      ],
      "bbox_max": [
        -1625.0,
        560.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1625.0,
      "bbox_min": [
        -1625.0,
        530.0,
        60.0
      ],
      "bbox_max": [
        -1625.0,
        560.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 555.0,
      "bbox_min": [
        -1685.0,
        528.0,
        80.0
      ],
      "bbox_max": [
        -1655.0,
        555.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        -1680.0,
        530.0,
        80.0
      ],
      "bbox_max": [
        -1680.0,
        535.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        -1680.0,
        528.0,
        80.0
      ],
      "bbox_max": [
        -1660.0,
        530.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        -1680.0,
        528.0,
        80.0
      ],
      "bbox_max": [
        -1680.0,
        530.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        -1615.0,
        530.0,
        80.0
      ],
      "bbox_max": [
        -1580.0,
        570.6521606445312,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -1614.9998779296875,
      "bbox_min": [
        -1615.0,
        530.0,
        80.0
      ],
      "bbox_max": [
        -1580.0,
        570.6521606445312,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 530.0,
      "bbox_min": [
        -1615.0,
        530.0,
        80.0
      ],
      "bbox_max": [
        -1580.0,
        530.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1615.0,
      "bbox_min": [
        -1655.0,
        415.0,
        60.0
      ],
      "bbox_max": [
        -1580.0,
        480.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        -1615.0,
        460.0,
        60.0
      ],
      "bbox_max": [
        -1580.0,
        460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1654.9998779296875,
      "bbox_min": [
        -1655.0,
        415.0,
        60.0
      ],
      "bbox_max": [
        -1625.0,
        460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": 188.59808349609375,
      "bbox_min": [
        -1645.0,
        430.0,
        60.0
      ],
      "bbox_max": [
        -1625.0,
        460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 1624.9998779296875,
      "bbox_min": [
        -1625.0,
        430.0,
        60.0
      ],
      "bbox_max": [
        -1625.0,
        460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -435.0,
      "bbox_min": [
        -1685.0,
        435.0,
        80.0
      ],
      "bbox_max": [
        -1655.0,
        462.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        -1680.0,
        455.0,
        80.0
      ],
      "bbox_max": [
        -1680.0,
        460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        -1680.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        -1660.0,
        462.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        -1680.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        -1680.0,
        462.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1615.0,
      "bbox_min": [
        -1615.0,
        419.34783935546875,
        80.0
      ],
      "bbox_max": [
        -1580.0,
        460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1579.9998779296875,
      "bbox_min": [
        -1615.0,
        419.34783935546875,
        80.0
      ],
      "bbox_max": [
        -1580.0,
        460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        -1615.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        -1580.0,
        460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        -1690.0,
        480.0,
        78.0
      ],
      "bbox_max": [
        -1670.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1670.0,
      "bbox_min": [
        -1670.0,
        480.0,
        78.0
      ],
      "bbox_max": [
        -1670.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2138.0,
      "bbox_min": [
        -2230.0,
        -396.2794189453125,
        292.0
      ],
      "bbox_max": [
        -2034.0,
        -288.0,
        428.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 380.0,
      "bbox_min": [
        -2230.0,
        -380.0,
        331.87689208984375
      ],
      "bbox_max": [
        -2138.0,
        -288.0,
        428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2230.0,
      "bbox_min": [
        -2230.0,
        -310.0,
        352.93389892578125
      ],
      "bbox_max": [
        -2230.0,
        -288.0,
        428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9967291355133057,
        -0.0,
        0.0808158740401268
      ],
      "plane_d": 2018.6728515625,
      "bbox_min": [
        -2060.0,
        -310.0,
        292.0
      ],
      "bbox_max": [
        -2034.0,
        -288.0,
        428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9967291355133057,
        0.0808158740401268
      ],
      "plane_d": 174.7239227294922,
      "bbox_min": [
        -2160.0,
        -210.0,
        305.3794860839844
      ],
      "bbox_max": [
        -2138.0,
        -188.3159637451172,
        428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9517086744308472,
        0.3070027828216553
      ],
      "plane_d": 85.46958923339844,
      "bbox_min": [
        -2160.0,
        -204.0,
        305.3794860839844
      ],
      "bbox_max": [
        -2138.0,
        -188.3159637451172,
        354.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6933767199516296,
        0.6933737993240356,
        0.19611559808254242
      ],
      "plane_d": 1545.96875,
      "bbox_min": [
        -2099.21728515625,
        -245.15045166015625,
        100.0
      ],
      "bbox_max": [
        -1602.5,
        338.75,
        295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3752506673336029,
        0.9059388637542725,
        0.19611626863479614
      ],
      "plane_d": 925.7670288085938,
      "bbox_min": [
        -2099.21728515625,
        -217.91183471679688,
        293.6522216796875
      ],
      "bbox_max": [
        -2094.997802734375,
        -216.22732543945312,
        295.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1602.5,
      "bbox_min": [
        -1602.5,
        337.5,
        100.0
      ],
      "bbox_max": [
        -1602.5,
        338.75,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -480.0,
      "bbox_min": [
        -1690.0,
        435.0,
        165.0
      ],
      "bbox_max": [
        -1560.0,
        510.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1559.9998779296875,
      "bbox_min": [
        -1560.0,
        435.0,
        165.0
      ],
      "bbox_max": [
        -1560.0,
        438.9979553222656,
        166.29705810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 510.0,
      "bbox_min": [
        -1690.0,
        480.0,
        165.0
      ],
      "bbox_max": [
        -1571.6717529296875,
        510.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -435.0,
      "bbox_min": [
        -1680.0,
        425.0,
        140.0
      ],
      "bbox_max": [
        -1580.0,
        455.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1654.9998779296875,
      "bbox_min": [
        -1655.0,
        425.0,
        140.0
      ],
      "bbox_max": [
        -1580.0,
        435.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1579.9998779296875,
      "bbox_min": [
        -1580.0,
        425.0,
        140.0
      ],
      "bbox_max": [
        -1580.0,
        435.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -435.0,
      "bbox_min": [
        -1680.0,
        427.0,
        145.0
      ],
      "bbox_max": [
        -1560.0,
        440.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1654.9998779296875,
      "bbox_min": [
        -1655.0,
        427.0,
        145.0
      ],
      "bbox_max": [
        -1580.0,
        435.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1579.9998779296875,
      "bbox_min": [
        -1580.0,
        427.0,
        145.0
      ],
      "bbox_max": [
        -1580.0,
        435.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        -1680.0,
        435.0,
        145.0
      ],
      "bbox_max": [
        -1560.0,
        440.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8000000715255737,
        0.6000000238418579,
        -0.0
      ],
      "plane_d": 1088.0001220703125,
      "bbox_min": [
        -1720.0,
        440.0,
        145.0
      ],
      "bbox_max": [
        -1660.0,
        480.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -455.0,
      "bbox_min": [
        -1685.0,
        455.0,
        145.0
      ],
      "bbox_max": [
        -1680.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        -1665.0,
        440.0,
        145.0
      ],
      "bbox_max": [
        -1660.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -455.0,
      "bbox_min": [
        -1665.0,
        455.0,
        145.0
      ],
      "bbox_max": [
        -1660.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1654.9998779296875,
      "bbox_min": [
        -1680.0,
        338.75,
        100.0
      ],
      "bbox_max": [
        -1602.5,
        460.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        -1680.0,
        435.0,
        100.0
      ],
      "bbox_max": [
        -1665.0,
        455.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -435.0,
      "bbox_min": [
        -1680.0,
        435.0,
        100.0
      ],
      "bbox_max": [
        -1665.0,
        435.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1615.0,
      "bbox_min": [
        -1615.0,
        338.75,
        100.0
      ],
      "bbox_max": [
        -1602.5,
        460.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -340.0,
      "bbox_min": [
        -1605.0,
        338.75,
        100.0
      ],
      "bbox_max": [
        -1602.5,
        340.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1602.5,
      "bbox_min": [
        -1602.5,
        338.75,
        100.0
      ],
      "bbox_max": [
        -1602.5,
        340.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1655.0,
      "bbox_min": [
        -1665.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        -1655.0,
        480.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": -457.94677734375,
      "bbox_min": [
        -1665.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        -1660.0,
        462.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        -1660.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        -1660.0,
        462.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        -1605.0,
        338.75,
        116.0
      ],
      "bbox_max": [
        -1580.0,
        460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -340.0,
      "bbox_min": [
        -1605.0,
        338.75,
        116.0
      ],
      "bbox_max": [
        -1602.5,
        340.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1602.5,
      "bbox_min": [
        -1602.5,
        338.75,
        116.0
      ],
      "bbox_max": [
        -1602.5,
        340.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        -1690.0,
        435.0,
        116.0
      ],
      "bbox_max": [
        -1655.0,
        460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        -1680.0,
        435.0,
        116.0
      ],
      "bbox_max": [
        -1665.0,
        455.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -435.0,
      "bbox_min": [
        -1680.0,
        435.0,
        116.0
      ],
      "bbox_max": [
        -1665.0,
        435.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1655.0,
      "bbox_min": [
        -1680.0,
        530.0,
        100.0
      ],
      "bbox_max": [
        -1615.0,
        566.3043212890625,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        -1680.0,
        535.0,
        100.0
      ],
      "bbox_max": [
        -1665.0,
        555.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 555.0,
      "bbox_min": [
        -1680.0,
        555.0,
        100.0
      ],
      "bbox_max": [
        -1665.0,
        555.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -1614.9998779296875,
      "bbox_min": [
        -1615.0,
        530.0,
        100.0
      ],
      "bbox_max": [
        -1615.0,
        566.3043212890625,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1655.0,
      "bbox_min": [
        -1665.0,
        510.0,
        100.0
      ],
      "bbox_max": [
        -1655.0,
        530.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 427.5362548828125,
      "bbox_min": [
        -1665.0,
        528.0,
        100.0
      ],
      "bbox_max": [
        -1660.0,
        530.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        -1660.0,
        528.0,
        100.0
      ],
      "bbox_max": [
        -1660.0,
        530.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 555.0,
      "bbox_min": [
        -1680.0,
        535.0,
        116.0
      ],
      "bbox_max": [
        -1665.0,
        555.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 530.0,
      "bbox_min": [
        -1615.0,
        510.0,
        116.0
      ],
      "bbox_max": [
        -1560.0,
        565.0,
        141.96554565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        -1615.0,
        530.0,
        116.0
      ],
      "bbox_max": [
        -1580.0,
        565.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1615.0,
      "bbox_min": [
        -1615.0,
        530.0,
        116.0
      ],
      "bbox_max": [
        -1615.0,
        565.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1560.0,
      "bbox_min": [
        -1560.0,
        510.0,
        140.0
      ],
      "bbox_max": [
        -1560.0,
        516.0587158203125,
        141.96554565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 550.0,
      "bbox_min": [
        -1720.0,
        510.0,
        145.0
      ],
      "bbox_max": [
        -1568.113037109375,
        555.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8000000715255737,
        -0.6000000238418579,
        0.0
      ],
      "plane_d": 1682.0001220703125,
      "bbox_min": [
        -1720.0,
        510.0,
        145.0
      ],
      "bbox_max": [
        -1660.0,
        550.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 535.0,
      "bbox_min": [
        -1685.0,
        535.0,
        145.0
      ],
      "bbox_max": [
        -1680.0,
        535.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        -1665.0,
        535.0,
        145.0
      ],
      "bbox_max": [
        -1660.0,
        550.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 535.0,
      "bbox_min": [
        -1665.0,
        535.0,
        145.0
      ],
      "bbox_max": [
        -1660.0,
        535.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1655.0,
      "bbox_min": [
        -1655.0,
        480.0,
        106.0
      ],
      "bbox_max": [
        -1655.0,
        510.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -145.0,
      "bbox_min": [
        -1720.0,
        480.0,
        140.0
      ],
      "bbox_max": [
        -1690.0,
        510.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        -1690.0,
        480.0,
        140.0
      ],
      "bbox_max": [
        -1690.0,
        510.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1720.0,
      "bbox_min": [
        -1720.0,
        480.0,
        145.0
      ],
      "bbox_max": [
        -1720.0,
        510.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112057685852051,
        -0.4043944478034973,
        0.07854446023702621
      ],
      "plane_d": 2450.442138671875,
      "bbox_min": [
        -1764.8831787109375,
        2298.338623046875,
        130.0
      ],
      "bbox_max": [
        -1661.9405517578125,
        2341.45556640625,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4056476056575775,
        -0.9140295386314392,
        -0.00014437820937018842
      ],
      "plane_d": 1424.3009033203125,
      "bbox_min": [
        -1764.8831787109375,
        2306.168212890625,
        426.8799133300781
      ],
      "bbox_max": [
        -1688.00927734375,
        2341.45556640625,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9140291213989258,
        -0.40564870834350586,
        0.0
      ],
      "plane_d": 2479.280029296875,
      "bbox_min": [
        -1680.0238037109375,
        2326.370849609375,
        460.0
      ],
      "bbox_max": [
        -1676.675537109375,
        2333.915283203125,
        475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.867123544216156,
        -0.38483482599258423,
        0.3162263035774231
      ],
      "plane_d": 2190.465087890625,
      "bbox_min": [
        -1696.6204833984375,
        2325.9521484375,
        531.0
      ],
      "bbox_max": [
        -1684.9156494140625,
        2340.0,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8175334930419922,
        -0.3628236651420593,
        -0.447211354970932
      ],
      "plane_d": 2468.423828125,
      "bbox_min": [
        -1696.6204833984375,
        2325.9521484375,
        531.0
      ],
      "bbox_max": [
        -1684.9156494140625,
        2340.0,
        541.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9140291213989258,
        -0.40564870834350586,
        0.0
      ],
      "plane_d": 2494.280029296875,
      "bbox_min": [
        -1699.8333740234375,
        2318.712646484375,
        460.0
      ],
      "bbox_max": [
        -1679.344970703125,
        2329.5244140625,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9140291213989258,
        -0.40564870834350586,
        0.0
      ],
      "plane_d": 2479.280029296875,
      "bbox_min": [
        -1680.0238037109375,
        2326.370849609375,
        460.0
      ],
      "bbox_max": [
        -1679.344970703125,
        2327.900390625,
        475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.867123544216156,
        -0.38483482599258423,
        0.3162263035774231
      ],
      "plane_d": 2190.465087890625,
      "bbox_min": [
        -1699.8333740234375,
        2318.712646484375,
        531.0
      ],
      "bbox_max": [
        -1689.564697265625,
        2329.5244140625,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8175334930419922,
        -0.3628236651420593,
        -0.447211354970932
      ],
      "plane_d": 2468.423828125,
      "bbox_min": [
        -1699.8333740234375,
        2318.712646484375,
        531.0
      ],
      "bbox_max": [
        -1689.564697265625,
        2329.5244140625,
        541.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5070119500160217,
        -0.2250133454799652,
        0.8320504426956177
      ],
      "plane_d": 980.03271484375,
      "bbox_min": [
        -1699.8333740234375,
        2312.6279296875,
        460.0
      ],
      "bbox_max": [
        -1680.0235595703125,
        2326.37158203125,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9140291213989258,
        -0.40564870834350586,
        0.0
      ],
      "plane_d": 2479.280029296875,
      "bbox_min": [
        -1686.1229248046875,
        2312.6279296875,
        460.0
      ],
      "bbox_max": [
        -1680.0235595703125,
        2326.37158203125,
        475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.867123544216156,
        -0.38483482599258423,
        0.3162263035774231
      ],
      "plane_d": 2190.465087890625,
      "bbox_min": [
        -1699.8333740234375,
        2316.680908203125,
        531.0
      ],
      "bbox_max": [
        -1693.22998046875,
        2321.265869140625,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32252857089042664,
        -0.8342534899711609,
        -0.44720956683158875
      ],
      "plane_d": 2720.107177734375,
      "bbox_min": [
        -1718.2432861328125,
        2309.33740234375,
        531.0
      ],
      "bbox_max": [
        -1695.2647705078125,
        2318.712646484375,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.867123544216156,
        -0.38483482599258423,
        0.3162263035774231
      ],
      "plane_d": 2190.465087890625,
      "bbox_min": [
        -1699.8333740234375,
        2314.794677734375,
        531.0
      ],
      "bbox_max": [
        -1695.2647705078125,
        2318.712646484375,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8175334930419922,
        -0.3628236651420593,
        -0.447211354970932
      ],
      "plane_d": 2468.423828125,
      "bbox_min": [
        -1699.8333740234375,
        2314.794677734375,
        531.0
      ],
      "bbox_max": [
        -1695.2647705078125,
        2318.712646484375,
        541.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8671222925186157,
        -0.38483428955078125,
        0.31623005867004395
      ],
      "plane_d": -802.846435546875,
      "bbox_min": [
        -1761.6485595703125,
        2339.98095703125,
        531.0
      ],
      "bbox_max": [
        -1761.60546875,
        2340.0,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8175309300422668,
        -0.3628225326538086,
        -0.4472169280052185
      ],
      "plane_d": -353.69708251953125,
      "bbox_min": [
        -1761.6396484375,
        2339.98583984375,
        531.0
      ],
      "bbox_max": [
        -1761.6077880859375,
        2340.0,
        531.0468139648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8671222925186157,
        -0.38483428955078125,
        0.31623005867004395
      ],
      "plane_d": -802.846435546875,
      "bbox_min": [
        -1767.0843505859375,
        2325.9521484375,
        531.0
      ],
      "bbox_max": [
        -1755.3795166015625,
        2340.0,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8175309300422668,
        -0.3628225326538086,
        -0.4472169280052185
      ],
      "plane_d": -353.69708251953125,
      "bbox_min": [
        -1767.0843505859375,
        2325.9521484375,
        531.0
      ],
      "bbox_max": [
        -1755.3795166015625,
        2340.0,
        541.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9974586963653564,
        0.07124704867601395
      ],
      "plane_d": 2080.4140625,
      "bbox_min": [
        -1867.6728515625,
        2100.0,
        200.0
      ],
      "bbox_max": [
        -1850.0,
        2110.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8671222925186157,
        -0.38483428955078125,
        0.31623005867004395
      ],
      "plane_d": -802.846435546875,
      "bbox_min": [
        -1762.4354248046875,
        2318.712646484375,
        531.0
      ],
      "bbox_max": [
        -1752.1666259765625,
        2329.52490234375,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34209343791007996,
        -0.884858250617981,
        0.31622451543807983
      ],
      "plane_d": 2457.4130859375,
      "bbox_min": [
        -1726.0,
        2305.916015625,
        531.0
      ],
      "bbox_max": [
        -1710.2177734375,
        2312.651123046875,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3605971038341522,
        -0.9327216744422913,
        0.0
      ],
      "plane_d": 1515.887451171875,
      "bbox_min": [
        -1757.5755615234375,
        2294.605712890625,
        460.0
      ],
      "bbox_max": [
        -1731.408935546875,
        2304.721923828125,
        475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3225288689136505,
        -0.834254264831543,
        -0.44720810651779175
      ],
      "plane_d": 1606.7391357421875,
      "bbox_min": [
        -1758.769775390625,
        2303.931884765625,
        531.0
      ],
      "bbox_max": [
        -1726.0,
        2321.265380859375,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8671222925186157,
        -0.38483428955078125,
        0.31623005867004395
      ],
      "plane_d": -802.846435546875,
      "bbox_min": [
        -1758.769775390625,
        2314.794677734375,
        531.0
      ],
      "bbox_max": [
        -1752.1666259765625,
        2321.265380859375,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8175309300422668,
        -0.3628225326538086,
        -0.4472169280052185
      ],
      "plane_d": -353.69708251953125,
      "bbox_min": [
        -1758.769775390625,
        2314.794677734375,
        531.0
      ],
      "bbox_max": [
        -1752.1666259765625,
        2321.265380859375,
        541.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3420935571193695,
        -0.8848586082458496,
        0.3162234425544739
      ],
      "plane_d": 1276.5076904296875,
      "bbox_min": [
        -1727.800537109375,
        2303.23583984375,
        531.0
      ],
      "bbox_max": [
        -1719.0673828125,
        2308.596435546875,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32252857089042664,
        -0.8342534899711609,
        -0.44720956683158875
      ],
      "plane_d": 2720.107177734375,
      "bbox_min": [
        -1727.80029296875,
        2303.23583984375,
        531.0
      ],
      "bbox_max": [
        -1719.0673828125,
        2308.596435546875,
        541.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3225288689136505,
        -0.834254264831543,
        -0.44720810651779175
      ],
      "plane_d": 1606.7391357421875,
      "bbox_min": [
        -1727.80029296875,
        2303.23583984375,
        531.0
      ],
      "bbox_max": [
        -1726.0,
        2308.596435546875,
        541.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8682432174682617,
        0.0,
        -0.49613896012306213
      ],
      "plane_d": 1671.9884033203125,
      "bbox_min": [
        -1850.0,
        1950.0,
        178.74642944335938
      ],
      "bbox_max": [
        -1820.0,
        2100.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1950.0,
      "bbox_min": [
        -1850.0,
        1950.0,
        187.91493225097656
      ],
      "bbox_max": [
        -1820.0,
        2100.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 165.0,
      "bbox_min": [
        -1578.2471923828125,
        440.0,
        141.96554565429688
      ],
      "bbox_max": [
        -1560.0,
        550.0,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 510.0,
      "bbox_min": [
        -1574.205322265625,
        480.0,
        165.0
      ],
      "bbox_max": [
        -1560.0,
        510.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -480.0,
      "bbox_min": [
        -1569.273681640625,
        480.0,
        165.0
      ],
      "bbox_max": [
        -1560.0,
        480.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 510.0,
      "bbox_min": [
        -1561.53759765625,
        510.0,
        141.96554565429688
      ],
      "bbox_max": [
        -1560.0,
        510.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 550.0,
      "bbox_min": [
        -1578.2471923828125,
        440.0,
        145.0
      ],
      "bbox_max": [
        -1560.0,
        550.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        -1560.1646728515625,
        440.0,
        164.67491149902344
      ],
      "bbox_max": [
        -1560.0,
        440.0,
        165.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}